// Final ID - 139

export let bidiotvMovies = [
    {
        "id":25,
        "contents":58,
        "name": {
            "en": "Hollywood",
            "ee": "Hollywood",
            "lv":"Hollywood",
            "lt":"Hollywood",
            "sr":"Холливоод",
            'el':"Χόλιγουντ",
            "de":"Hollywood",
            'fr':"Hollywood",
            "cs":"Hollywood",
            "es": "Hollywood",
            "pt": "Hollywood"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1001,
        name: '3 things James Gunn told \'GotG\' fans during his watch party',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/3-things-James-Gunn-told-GotG-fans-during-his-watch-party.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/3+things+James+Gunn+told+%60GotG\'+fans+during+his+watch+party.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1002,
        name: '5 Times Elle Fanning was a total red carpet princess',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/5-Times-Elle-Fanning-was-a-total-red-carpet-princess.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/5+Times+Elle+Fanning+was+a+total+red+carpet+princess.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1003,
        name: 'All the FBF you need of Victoria Beckham as Posh Spice',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/All-the-FBF-you-need-of-Victoria-Beckham-as-Posh-Spice.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/All+the+FBF+you+need+of+Victoria+Beckham+as+Posh+Spice.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1004,
        name: 'All the red carpets Anya Taylor-Joy came to slay',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/All-the-red-carpets-Anya-Taylor-Joy-came-to-slay.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/All+the+red+carpets+Anya+Taylor-Joy+came+to+slay.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1005,
        name: 'Besides Ariana Grande, here are 5 stars Victoria Mone\'t wrote music for',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Besides-Ariana-Grande%2C-here-are-5-stars-Victoria-Mone\'t-wrote-music-for.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Besides+Ariana+Grande%2C+here+are+5+stars+Victoria+Mone\'t+wrote+music+for.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1006,
        name: 'Black Widow fans in the UK rejoicing over earlier release date',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Black-Widow-fans-in-the-UK-rejoicing-over-earlier-release-date.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Black+Widow+fans+in+the+UK+rejoicing+over+earlier+release+date.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1007,
        name: 'Cynthia Rowley gave birth to a Gen-Z Blair Waldorf',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Cynthia-Rowley-gave-birth-to-a-Gen-Z-Blair-Waldorf.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Cynthia+Rowley+gave+birth+to+a+Gen-Z+Blair+Waldorf.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1008,
        name: 'Disney reportedly in talks to release \'Black Widow\' straight to streaming',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Disney-reportedly-in-talks-to-release-\'Black-Widow\'-straight-to-streaming-copy.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Disney+reportedly+in+talks+to+release+\'Black+Widow\'+straight+to+streaming.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1009,
        name: 'Drake, Nicki & Beyonce\' all drop surprise music',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Drake%2C-Nicki-%26-Beyonce\'-all-drop-surprise-music.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Drake%2C+Nicki+%26+Beyonce\'+all+drop+surprise+music.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1010,
        name: 'Fans watch sparks fly between JLo and Diddy in front of Arod',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Fans-watch-sparks-fly-between-JLo-and-Diddy-in-front-of-Arod.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Fans+watch+sparks+fly+between+JLo+and+Diddy+in+front+of+Arod.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1011,
        name: 'Five Fascinating facts about David Attenborough\'s life',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Five-Fascinating-facts-about-David-Attenborough\'s-life.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Five+Fascinating+facts+about+David+Attenborough\'s+life.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1012,
        name: 'Frank Ocean and Lindsay Lohan both make triumphant music comebacks',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Frank-Ocean-and-Lindsay-Lohan-both-make-triumphant-music-comebacks.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Frank+Ocean+and+Lindsay+Lohan+both+make+triumphant+music+comebacks.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1013,
        name: 'From Australia to \'Hollywood\', Samara Weaving has arrived',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/From-Australia-to-\'Hollywood\'%2C-Samara-Weaving-has-arrived.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/From+Australia+to+\'Hollywood\'%2C+Samara+Weaving+has+arrived.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1014,
        name: 'George Clooney\'s top 3 OG movie roles',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/George-Clooney\'s-top-3-OG-movie-roles.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/George+Clooney\'s+top+3+OG+movie+roles.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1015,
        name: 'Meet the classically-trained actor who became Sex Education\'s biggest star',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Meet-the-classically-trained-actor-who-became-Sex-Education\'s-biggest-star.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Meet+the+classically-trained+actor+who+became+Sex+Education\'s+biggest+star.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1016,
        name: 'Gigi Hadid\'s mom Yolanda officially confirms the model\'s pregnancy',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Gigi-Hadid\'s-mom-Yolanda-officially-confirms-the-model\'s-pregnancy.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Gigi+Hadid\'s+mom+Yolanda+officially+confirms+the+model\'s+pregnancy.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1017,
        name: 'Gwyneth Paltrow donates Oscar dress (she hates anyway) for Covid-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Gwyneth-Paltrow-donates-Oscar-dress-(she-hates-anyway)-for-Covid-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Gwyneth+Paltrow+donates+Oscar+dress+(she+hates+anyway)+for+Covid-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1018,
        name: 'Gwyneth Paltrow\'s socially distant party has nothing on these block parties',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Gwyneth-Paltrow\'s-socially-distant-party-has-nothing-on-these-block-parties.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Gwyneth+Paltrow\'s+socially+distant+party+has+nothing+on+these+block+parties.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1019,
        name: 'Harry Styles in talks to play Boy George in biopic',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Harry-Styles-in-talks-to-play-Boy-George-in-biopic.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Harry+Styles+in+talks+to+play+Boy+George+in+biopic.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1020,
        name: 'Hayley Kiyoko\'s daily lounge outfits during corona are so relatable',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Hayley-Kiyoko\'s-daily-lounge-outfits-during-corona-are-so-relatable.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Hayley+Kiyoko\'s+daily+lounge+outfits+during+corona+are+so+relatable.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1021,
        name: 'He\'s got the biggest feet in the world & they\'re still growing',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/He\'s-got-the-biggest-feet-in-the-world-%26-they\'re-still-growing!.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/He\'s+got+the+biggest+feet+in+the+world+%26+they\'re+still+growing.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1022,
        name: 'Hollywood on Netflix Which characters were actually real',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Hollywood-on-Netflix-Which-characters-were-actually-real.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Hollywood+on+Netflix+Which+characters+were+actually+real.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1023,
        name: 'How Hollywood got bit by \'Parasite\' star Park So-Dam',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How-Hollywood-got-bit-by-\'Parasite\'-star-Park-So-Dam.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How+Hollywood+got+bit+by+\'Parasite\'+star+Park+So-Dam.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1024,
        name: 'How Jackson Wang became China\'s golden boy',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How-Jackson-Wang-became-China\'s-golden-boy.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How+Jackson+Wang+became+China\'s+golden+boy.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1025,
        name: 'How Peyton List went from Disney good-girl to Gen-Z beauty queen',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How-Peyton-List-went-from-Disney-good-girl-to-Gen-Z-beauty-queen.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How+Peyton+List+went+from+Disney+good-girl+to+Gen-Z+beauty+queen.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1026,
        name: 'How Victoria\'s Secret model Josephine Skriver is celebrating her 27th birthday',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How-Victoria\'s-Secret-model-Josephine-Skriver-is-celebrating-her-27th-birthday.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How+Victoria\'s+Secret+model+Josephine+Skriver+is+celebrating+her+27th+birthday.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1027,
        name: 'If you haven\'t seen these 4 Audrey Hepburn films, you need a history class',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/If-you-haven\'t-seen-these-4-Audrey-Hepburn-films%2C-you-need-a-history-class.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/If+you+haven\'t+seen+these+4+Audrey+Hepburn+films%2C+you+need+a+history+class.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1028,
        name: 'It\'s a pop paradise with Ariana, Bieber, Hailee & Kim Petras',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/It\'s-a-pop-paradise-with-Ariana%2C-Bieber%2C-Hailee-%26-Kim-Petras.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/It\'s+a+pop+paradise+with+Ariana%2C+Bieber%2C+Hailee+%26+Kim+Petras.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1029,
        name: 'Jake Gyllenhaal admits he\'s gone full hipster & baking sourdough',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Jake-Gyllenhaal-admits-he\'s-gone-full-hipster-%26-baking-sourdough.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Jake+Gyllenhaal+admits+he\'s+gone+full+hipster+%26+baking+sourdough.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1030,
        name: 'Jane Fonda releases her own line of sweat suits perfect for quarantine',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Jane-Fonda-releases-her-own-line-of-sweat-suits-perfect-for-quarantine.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Jane+Fonda+releases+her+own+line+of+sweat+suits+perfect+for+quarantine.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1031,
        name: 'Japan\'s having to watch sakura season pass them by & it sucks',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Japan\'s-having-to-watch-sakura-season-pass-them-by-%26-it-sucks.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Japan\'s+having+to+watch+sakura+season+pass+them+by+%26+it+sucks.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1032,
        name: 'Justin Bieber reprimands Hailey in the most awkward Facebook Live',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Justin-Bieber-reprimands-Hailey-in-the-most-awkward-Facebook-Live.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Justin+Bieber+reprimands+Hailey+in+the+most+awkward+Facebook+Live.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1033,
        name: 'Lady Gaga jokes her next single is called \'Tim Cook\'',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Lady-Gaga-jokes-her-next-single-is-called-Tim-Cook.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Lady+Gaga+jokes+her+next+single+is+called+\'Tim+Cook\'.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1034,
        name: 'Logan Paul begs followers to buy his $90,000 couch',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Logan-Paul-begs-followers-to-buy-his-%2490%2C000-couch.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Logan+Paul+begs+followers+to+buy+his+%2490%2C000+couch.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1035,
        name: 'Marlo Kelly The mean girl from Dare Me who everyone loves',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Marlo-Kelly-The-mean-girl-from-Dare-Me-who-everyone-loves.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Marlo+Kelly+The+mean+girl+from+Dare+Me+who+everyone+loves.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1036,
        name: 'Meet the classically-trained actor who became Sex Education\'s biggest star',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Meet-the-classically-trained-actor-who-became-Sex-Education\'s-biggest-star.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Meet+the+classically-trained+actor+who+became+Sex+Education\'s+biggest+star.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1037,
        name: 'Miranda Kerr\'s 5 lessons in self-care',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Miranda-Kerr\'s-5-lessons-in-self-care.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Miranda+Kerr\'s+5+lessons+in+self-care.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1038,
        name: 'Newbies Chloe x Halle and Justine Skye blow everyone out the water',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Newbies-Chloe-x-Halle-%26amp%3B-Justine-Skye-blow-everyone-out-the-water.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Newbies+Chloe+x+Halle+%26amp%3B+Justine+Skye+blow+everyone+out+the+water.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1039,
        name: 'Patricia Arquette\'s 5 best on-screen roles you have to see',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Patricia-Arquette\'s-5-best-on-screen-roles-you-have-to-see.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Patricia+Arquette\'s+5+best+on-screen+roles+you+have+to+see.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1040,
        name: 'Power pop from Demi Lovato, Sam Smith and even Kelly Rowland',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Power-pop-from-Demi-Lovato%2C-Sam-Smith-and-even-Kelly-Rowland.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Power+pop+from+Demi+Lovato%2C+Sam+Smith+and+even+Kelly+Rowland.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1041,
        name: 'Quavo spends 29th birthday isolating & that\'s not a bad thing',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Quavo-spends-29th-birthday-isolating-%26-that\'s-not-a-bad-thing.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Quavo+spends+29th+birthday+isolating+%26+that\'s+not+a+bad+thing.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1042,
        name: 'Queen\'s legendary guitarist is ready to get \'preachy\' about veganism',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Queen\'s-legendary-guitarist-is-ready-to-get-\'preachy\'-about-veganism.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Queen\'s+legendary+guitarist+is+ready+to+get+\'preachy\'+about+veganism.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1043,
        name: 'Record Breakers This guy broke 3 records in parkour',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Record-Breakers-This-guy-broke-3-records-in-parkour.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Record+Breakers+This+guy+broke+3+records+in+parkour.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1044,
        name: 'Remember Rami Malek in Twilight and Gilmore Girls',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Remember-Rami-Malek-in-Twilight-and-Gilmore-Girls.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Remember+Rami+Malek+in+Twilight+and+Gilmore+Girls.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1045,
        name: 'Russia\'s LARPing scene through the eyes of an elf',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Russia\'s-LARPing-scene-through-the-eyes-of-an-elf.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Russia\'s+LARPing+scene+through+the+eyes+of+an+elf.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1046,
        name: 'Spencer Pratt to Lauren Conrad \'Those houses you own are because of me\'',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Spencer-Pratt-to-Lauren-Conrad-\'Those-houses-you-own-are-because-of-me.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Spencer+Pratt+to+Lauren+Conrad+\'Those+houses+you+own+are+because+of+me\'.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1047,
        name: 'Stella Maxwell has some majorly hot (and famous) exes',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Stella-Maxwell-has-some-majorly-hot-(and-famous)-exes.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Stella+Maxwell+has+some+majorly+hot+(and+famous)+exes.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1048,
        name: 'The 3 wildest revelations about Dennis Rodman in The Last Dance',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/The-3-wildest-revelations-about-Dennis-Rodman-in-The-Last-Dance.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/The+3+wildest+revelations+about+Dennis+Rodman+in+The+Last+Dance.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1049,
        name: 'This is exactly how long we need to wait for the Marvel movies',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/This-is-exactly-how-long-we-need-to-wait-for-the-Marvel-movies.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/This+is+exactly+how+long+we+need+to+wait+for+the+Marvel+movies.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1050,
        name: 'Three familiar faces we want to see in season 2 of The Mandalorian',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Three-familiar-faces-we-want-to-see-in-season-2-of-The-Mandalorian.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Three+familiar+faces+we+want+to+see+in+season+2+of+The+Mandalorian.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1051,
        name: 'Three Fun Facts about Mikey from Social House',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Three-Fun-Facts-about-Mikey-from-Social-House.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Three+Fun+Facts+about+Mikey+from+Social+House.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1052,
        name: 'Travis Scott celebrates 28th with a Fortnite record & potential n 1',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Travis-Scott-celebrates-28th-with-a-Fortnite-record-%26-potential-n-1.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Travis+Scott+celebrates+28th+with+a+Fortnite+record+%26+potential+n+1.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1053,
        name: 'Trick Shot Talent- Javi\'s freestyle with a football is mesmerizing',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Trick-Shot-Talent--Javi\'s-freestyle-with-a-football-is-mesmerizing.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Trick+Shot+Talent-+Javi\'s+freestyle+with+a+football+is+mesmerizing.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1054,
        name: 'Trick Shot Talent- The 19-year-old self-made golfing extraordinaire',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Trick-Shot-Talent--The-19-year-old-self-made-golfing-extraordinaire.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Trick+Shot+Talent-+The+19-year-old+self-made+golfing+extraordinaire.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1055,
        name: 'What exactly has Chiara Ferragni been up to lately',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/What-exactly-has-Chiara-Ferragni-been-up-to-lately.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/What+exactly+has+Chiara+Ferragni+been+up+to+lately.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1056,
        name: 'Why are celebs getting naked during corona',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Why-are-celebs-getting-naked-during-corona.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Why+are+celebs+getting+naked+during+corona.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1057,
        name: 'Why fans are confused about Halsey\'s incredible `Little Mermaid\' performance',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Why-fans-are-confused-about-Halsey\'s-incredible-%60Little-Mermaid\'-performance.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Why+fans+are+confused+about+Halsey\'s+incredible+%60Little+Mermaid\'+performance.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1058,
        name: 'You\'ll never guess with whom Harry Potter would want to quarantine with',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/You\'ll-never-guess-with-whom-Harry-Potter-would-want-to-quarantine-with.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/You\'ll+never+guess+with+whom+Harry+Potter+would+want+to+quarantine+with.mp4',
        filename: '' } ]
    },
    {
        "id":29,
        "contents":32,
        "name": {
            "en": "Covid-19",
            "ee": "Covid-19",
            "lv": "Covid-19",
            "lt": "Covid-19",
            "sr": "Ковид-19",
            'el': "Κορωνοϊός",
            "de": "Covid-19",
            "cs": "Covid-19",
            "es": "Covid-19",
            "pt": "Covid-19"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1120,
        name: 'A nurse\'s plea reveals they\'re dealing with more than you think',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/A-nurse-plea-reveals-they\'re-dealing-with-more-than-you-think.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/A+nurse\'s+plea+reveals+they\'re+dealing+with+more+than+you+think.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1059,
        name: 'Bill Gates knew the world wasn\'t ready for a pandemic back in 2015',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Bill-Gates-knew-the-world-wasn\'t-ready-for-a-pandemic-back-in-2015.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Bill+Gates+knew+the+world+wasn\'t+ready+for+a+pandemic+back+in+2015.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1060,
        name: 'Britney Spears coming out as a Socialist is the best plot twist of Covid-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Britney-Spears-coming-out-as-a-Socialist-is-the-best-plot-twist-of-Covid-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Britney+Spears+coming+out+as+a+Socialist+is+the+best+plot+twist+of+Covid-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1061,
        name: 'Can dogs be trained to detect COVID-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Can-dogs-be-trained-to-detect-COVID-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Can+dogs+be+trained+to+detect+COVID-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1062,
        name: 'Cardi B\'s \'Coronavirus Rant Part 2\' has a new big warning',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Cardi-B\'s-\'Coronavirus-Rant-Part-2\'-has-a-new-big-warning.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Cardi+B\'s+\'Coronavirus+Rant+Part+2\'+has+a+new+big+warning.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1063,
        name: 'Cardi B\'s advice to graduates is actually really smart',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Cardi-B\'s-advice-to-graduates-is-actually-really-smart.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Cardi+B\'s+advice+to+graduates+is+actually+really+smart.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1064,
        name: 'Chanel, Tommy, Armani... the whole luxury gang\'s here to fight COVID-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Chanel%2C-Tommy%2C-Armani...-the-whole-luxury-gang\'s-here-to-fight-COVID-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Chanel%2C+Tommy%2C+Armani...+the+whole+luxury+gang\'s+here+to+fight+COVID-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1065,
        name: 'Chris Hemsworth will calm kids with guided meditations',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Chris-Hemsworth-will-calm-kids-with-guided-meditations.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Chris+Hemsworth+will+calm+kids+with+guided+meditations.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1066,
        name: 'COVID-19 Weekly Recap Relaxed lockdowns, 4 million global cases and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/COVID-19-Weekly-Recap-Relaxed-lockdowns%2C-4-million-global-cases-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/COVID-19+Weekly+Recap+Relaxed+lockdowns%2C+4+million+global+cases+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1067,
        name: 'COVID-19 Weekly Recap Relaxed lockdowns, stimulus packages & more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/COVID-19-Weekly-Recap-Relaxed-lockdowns%2C-stimulus-packages-%26-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/COVID-19+Weekly+Recap+Relaxed+lockdowns%2C+stimulus+packages+%26+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1068,
        name: 'Did you ever think these companies could help in a pandemic',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Did-you-ever-think-these-companies-could-help-in-a-pandemic.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Did+you+ever+think+these+companies+could+help+in+a+pandemic.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1069,
        name: 'Discrimination continues to spread globally alongside COVID-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Discrimination-continues-to-spread-globally-alongside-COVID-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Discrimination+continues+to+spread+globally+alongside+COVID-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1070,
        name: 'Doing my part in the pandemic- A personal peek inside Italy\'s Red Cross',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Doing-my-part-in-the-pandemic-A-personal-peek-inside-Italy\'s-Red-Cross.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Doing+my+part+in+the+pandemic-+A+personal+peek+inside+Italy\'s+Red+Cross.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1071,
        name: 'Doing my part in the pandemic- Helping those without a home',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Doing-my-part-in-the-pandemic-Helping-those-without-a-home.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Doing+my+part+in+the+pandemic-+Helping+those+without+a+home.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1072,
        name: 'Dua Lipa doesn\'t think the world should go back to \'normal\'',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Dua-Lipa-doesn\'t-think-the-world-should-go-back-to-\'normal\'.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Dua+Lipa+doesn\'t+think+the+world+should+go+back+to+\'normal\'.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1073,
        name: 'Europe\'s homeless are going hungry amid COVID-19 lockdowns',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Europe\'s-homeless-are-going-hungry-amid-COVID-19-lockdowns.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Europe\'s+homeless+are+going+hungry+amid+COVID-19+lockdowns.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1074,
        name: 'Experts predict the next global crisis could be food shortages',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Experts-predict-the-next-global-crisis-could-be-food-shortages.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Experts+predict+the+next+global+crisis+could+be+food+shortages.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1075,
        name: 'Fake COVID-19 cures and treatments are getting out of hand',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Fake-COVID-19-cures-and-treatments-are-getting-out-of-hand.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Fake+COVID-19+cures+and+treatments+are+getting+out+of+hand.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1076,
        name: 'Five ways we\'re creating the perfect environment for viruses',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Five-ways-we\'re-creating-the-perfect-environment-for-viruses.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Five+ways+we\'re+creating+the+perfect+environment+for+viruses.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1077,
        name: 'Gaza\'s fearless four risking it all in the fight against COVID-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Gaza\'s-fearless-four-risking-it-all-in-the-fight-against-COVID-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Gaza\'s+fearless+four+risking+it+all+in+the+fight+against+COVID-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1078,
        name: 'Here\'s how countries are prepping for tourism after COVID-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Here\'s-how-countries-are-prepping-for-tourism-after-COVID-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Here\'s+how+countries+are+prepping+for+tourism+after+COVID-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1079,
        name: 'Here\'s what astronauts can teach us about self-isolation',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Here\'s-what-astronauts-can-teach-us-about-self-isolation.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Here\'s+what+astronauts+can+teach+us+about+self-isolation.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1080,
        name: 'How to stay safe while grocery shopping during a pandemic',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/How-to-stay-safe-while-grocery-shopping-during-a-pandemic.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/How+to+stay+safe+while+grocery+shopping+during+a+pandemic.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1081,
        name: 'Kylie Jenner using Kylie Skin factory to donate hand sanitizers',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Kylie-Jenner-using-Kylie-Skin-factory-to-donate-hand-sanitizers.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Kylie+Jenner+using+Kylie+Skin+factory+to+donate+hand+sanitizers.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1082,
        name: 'Martha Stewart gives out strict beauty rules for quarantine',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Martha-Stewart-gives-out-strict-beauty-rules-for-quarantine.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Martha+Stewart+gives+out+strict+beauty+rules+for+quarantine.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1083,
        name: 'The artists inspiring people to wear face masks in Gaza',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/The-artists-inspiring-people-to-wear-face-masks-in-Gaza.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/The+artists+inspiring+people+to+wear+face+masks+in+Gaza.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1084,
        name: 'The race to find a COVID-19 vaccine is ramping up',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Three-apps-being-used-to-stop-COVID-19-in-its-tracks.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/The+race+to+find+a+COVID-19+vaccine+is+ramping+up.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1085,
        name: 'Three apps being used to stop COVID-19 in its tracks',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Three-apps-being-used-to-stop-COVID-19-in-its-tracks.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Three+apps+being+used+to+stop+COVID-19+in+its+tracks.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1086,
        name: 'Twenty One Pilots & Liam Payne drop first music from quarantine',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Twenty-One-Pilots-%26-Liam-Payne-drop-first-music-from-quarantine.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Twenty+One+Pilots+%26+Liam+Payne+drop+first+music+from+quarantine.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1087,
        name: 'Viruses & diseases don\'t stand a chance against the UVD Robot',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Viruses-%26-diseases-don\'t-stand-a-chance-against-the-UVD-Robot.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Viruses+%26+diseases+don\'t+stand+a+chance+against+the+UVD+Robot.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1088,
        name: 'Would you expose yourself to COVID-19 to help find a vaccine',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Would-you-expose-yourself-to-COVID-19-to-help-find-a-vaccine.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Would+you+expose+yourself+to+COVID-19+to+help+find+a+vaccine.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1089,
        name: 'You have to see Blue Ivy\'s adorable PSA to wash your hands',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/You-have-to-see-Blue-Ivy\'s-adorable-PSA-to-wash-your-hands.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/You+have+to+see+Blue+Ivy\'s+adorable+PSA+to+wash+your+hands.mp4',
        filename: '' } ]
    },
    {
        "id":28,
        "contents":12,
        "name": {
            "en": "Entertainment",
            "ee": "Meelelahutus",
            "lv": "Izklaide",
            "lt": "Pramogos", 
            "sr": "Забава",
            'el':"Ψυχαγωγία",
            "de":"Unterhaltung",
            "fr":"Divertissement",
            "it":"Divertimento",
            "cs":"Zábava",
            "es": "Entretenimiento",
            "pt": "Entretenimento"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1090,
        name: 'Are you of the 1.7 million who downloaded Quibi',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Are-you-of-the-1.7-million-who-downloaded-Quibi.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Are+you+of+the+1.7+million+who+downloaded+Quibi.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1091,
        name: 'Cleaning up beaches and creating art, one butt at a time',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Cleaning-up-beaches-and-creating-art%2C-one-butt-at-a-time.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Cleaning+up+beaches+and+creating+art%2C+one+butt+at+a+time.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1092,
        name: 'Five Fun facts about Mean Girls Broadway star Sabrina Carpenter',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Five-Fun-facts-about-Mean-Girls-Broadway-star-Sabrina-Carpenter.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Five+Fun+facts+about+Mean+Girls+Broadway+star+Sabrina+Carpenter.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1093,
        name: 'How to photo transfer anything A wooden gift for mom',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/How-to-photo-transfer-anything-A-wooden-gift-for-mom.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/How+to+photo+transfer+anything+A+wooden+gift+for+mom.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1094,
        name: 'How to Photo Transfer Anything Images on rocks made easy',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/How-to-Photo-Transfer-Anything-Images-on-rocks-made-easy.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/How+to+Photo+Transfer+Anything+Images+on+rocks+made+easy.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1095,
        name: 'How to Photo Transfer Anything Screen printing made easy',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/How-to-Photo-Transfer-Anything-Screen-printing-made-easy.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/How+to+Photo+Transfer+Anything+Screen+printing+made+easy.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1096,
        name: 'One man\'s mission to get the wheels turning in Colombia',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/One-man\'s-mission-to-get-the-wheels-turning-in-Colombia.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/One+man\'s+mission+to+get+the+wheels+turning+in+Colombia.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1097,
        name: 'Online Life How these creatives are staying inspired during lockdown',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Online-Life-How-these-creatives-are-staying-inspired-during-lockdown.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Online-Life-How-these-creatives-are-staying-inspired-during-lockdown.jpg',
        filename: '' },
      { duration: 'Watch Now',
        id: 1098,
        name: 'Online Life How this dancer\'s turning adversity into opportunity',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Online-Life-How-this-dancer\'s-turning-adversity-into-opportunity.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Online+Life+How+this+dancer\'s+turning+adversity+into+opportunity.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1099,
        name: 'Online Life Tips from a teacher who\'s gone digital during lockdown',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Online-Life-Tips-from-a-teacher-who\'s-gone-digital-during-lockdown.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Online+Life+Tips+from+a+teacher+who\'s+gone+digital+during+lockdown.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1100,
        name: 'Seth Rogen\'s 5 most comforting comedies to watch now',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Seth-Rogen\'s-5-most-comforting-comedies-to-watch-now.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Seth+Rogen\'s+5+most+comforting+comedies+to+watch+now.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1101,
        name: 'The Zoom blind dating service all singles should know about',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/The-Zoom-blind-dating-service-all-singles-should-know-about.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/The+Zoom+blind+dating+service+all+singles+should+know+about.mp4',
        filename: '' } ]
    },
    {
        "id":37,
        "contents":5,
        "name": {
            "en": "Adventure",
            "ee": "Seiklus",
            "lv":"Piedzīvojumu",
            "lt":"Nuotykiai",
            "sr":"Авантура",
            "el":"Περιπέτεια",
            "de":"Abenteuer",
            "fr":"Aventure",
            "it":"Avventura",
            "cs":"Dobrodružství",
            "es": "Aventura",
            "pt": "Aventura"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1102,
        name: 'Bucket list opportunity- Siberian ice rafting is 100% unique',
        preview: 'https://cdn.mobiotv.com/bidiotv/Adventure/Bucket-list-opportunity-Siberian-ice-rafting-is-100%25-unique.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Adventure/Bucket+list+opportunity-+Siberian+ice+rafting+is+100%25+unique.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1103,
        name: 'Muniellos One of the most exclusive forests in the world',
        preview: 'https://cdn.mobiotv.com/bidiotv/Adventure/Muniellos-One-of-the-most-exclusive-forests-in-the-world.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Adventure/Muniellos+One+of+the+most+exclusive+forests+in+the+world.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1104,
        name: 'The fascinating investigation findings after the Titanic sank',
        preview: 'https://cdn.mobiotv.com/bidiotv/Adventure/The-fascinating-investigation-findings-after-the-Titanic-sank.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Adventure/The+fascinating+investigation+findings+after+the+Titanic+sank.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1105,
        name: 'This 85-year-old grandma games harder than people half her age',
        preview: 'https://cdn.mobiotv.com/bidiotv/Adventure/This-85-year-old-grandma-games-harder-than-people-half-her-age.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Adventure/This+85-year-old+grandma+games+harder+than+people+half+her+age.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1106,
        name: 'With this e-bike, you can cycle on water',
        preview: 'https://cdn.mobiotv.com/bidiotv/Adventure/With-this-e-bike%2C-you-can-cycle-on-water.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Adventure/With+this+e-bike%2C+you+can+cycle+on+water.mp4',
        filename: '' },
        ]        
    },
    {
        "id":30,
        "contents":6,
        "name": {
            "en": "Health",
            "ee": "Tervis",
            "lv":"Veselība",
            "lt":"Sveikata",
            "sr":"Здравље",
            "el":"Υγεία",
            "de":"Gesundheit",
            "fr":"Santé",
            "it":"Salute",
            "cs":"Zdraví",
            "es": "Salud",
            "pt": "Saúde"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1107,
        name: 'Level up your fitness and relationship with these acroyoga moves',
        preview: 'https://cdn.mobiotv.com/bidiotv/Health/Level-up-your-fitness-and-relationship-with-these-acroyoga-moves.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Health/Level+up+your+fitness+and+relationship+with+these+acroyoga+moves.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1108,
        name: 'Life Boost Influencers- Roz the diva will make you sweat and smile',
        preview: 'https://cdn.mobiotv.com/bidiotv/Health/Life-Boost-Influencers--Roz-the-diva-will-make-you-sweat-and-smile.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Health/Life+Boost+Influencers-+Roz+the+diva+will+make+you+sweat+and+smile.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1109,
        name: 'Life Boost Influencers- The ASMR-tist helping quarantined fans relax',
        preview: 'https://cdn.mobiotv.com/bidiotv/Health/Life-Boost-Influencers--The-ASMR-tist-helping-quarantined-fans-relax.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Health/Life+Boost+Influencers-+The+ASMR-tist+helping+quarantined+fans+relax.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1110,
        name: 'Shay Mitchell is quarantining just like us- with wine and a yoga mat',
        preview: 'https://cdn.mobiotv.com/bidiotv/Health/Shay-Mitchell-is-quarantining-just-like-us-with-wine-and-a-yoga-mat.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Health/Shay+Mitchell+is+quarantining+just+like+us-+with+wine+and+a+yoga+mat.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1111,
        name: 'The Colombian prison that lets inmates get a taste of freedom and nature',
        preview: 'https://cdn.mobiotv.com/bidiotv/Health/The-Colombian-prison-that-lets-inmates-get-a-taste-of-freedom-and-nature.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Health/The+Colombian+prison+that+lets+inmates+get+a+taste+of+freedom+and+nature.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1112,
        name: 'TV doctors have a video message for real doctors',
        preview: 'https://cdn.mobiotv.com/bidiotv/Health/TV-doctors-have-a-video-message-for-real-doctors.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Health/TV+doctors+have+a+video+message+for+real+doctors.mp4',
        filename: '' } ]
    },
    {
        "id":31,
        "contents":5,
        "name": {
            "en": "Cooking",
            "ee": "Kokkamine",
            "lv":"Ēdienu gatavošana",
            "lt":"Gaminimas",
            "sr":"Кување",
            "el":"Μαγείρεμα",
            "de":"Kochen",
            "fr":"Cuisine",
            "it":"cucinando",
            "cs":"Vaření",
            "es": "Cocinar",
            "pt": "Culinária"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1113,
        name: 'All the recipes Gigi & Bella Hadid have cooked in quarantine',
        preview: 'https://cdn.mobiotv.com/bidiotv/Cooking/All-the-recipes-Gigi-%26-Bella-Hadid-have-cooked-in-quarantine.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Cooking/All+the+recipes+Gigi+%26+Bella+Hadid+have+cooked+in+quarantine.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1114,
        name: 'Craving something sweet Make a \'Sugar Bomb\' milkshake',
        preview: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving-something-sweet-Make-a-\'Sugar-Bomb\'-milkshake.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving+something+sweet+Make+a+\'Sugar+Bomb\'+milkshake.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1115,
        name: 'Craving someothing sweet Try making this rainbow pudding shake',
        preview: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving-something-sweet-Try-making-this-rainbow-pudding-shake.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving+something+sweet+Try+making+this+rainbow+pudding+shake.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1116,
        name: 'Craving something sweet Try making this strawberry milkshake',
        preview: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving-something-sweet-Try-making-this-strawberry-milkshake.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving+something+sweet+Try+making+this+strawberry+milkshake.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1117,
        name: 'Craving something sweet Try making this yummy Oreo milkshake!',
        preview: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving-something-sweet-Try-making-this-yummy-Oreo-milkshake.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving+something+sweet+Try+making+this+yummy+Oreo+milkshake!.mp4',
        filename: '' } ]
    },
    {
        "id":27,
        "contents":19,
        "name": {
            "en": "Sports and Gaming",
            "ee": "Sport ja mängud",
            "lv":"Sports un spēles",
            "lt":"Sportas ir žaidimai",
            "sr":"Спорт и игре",
            "el":"Αθλητισμός και τυχερά παιχνίδια",
            "de":"Sport und Spiele",
            "fr":"Sports et jeux",
            "it":"Sport e gioco",
            "cs":"Sport a hry",
            "es": "Deportes y juegos",
            "pt": "Esportes e Jogos"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1118,
        name: 'Esports - Can the industry save a country\'s economy',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports---Can-the-industry-save-a-country\'s-economy.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports+-+Can+the+industry+save+a+country\'s+economy.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1119,
        name: 'Esports news Dreamhack, Twitch, Sinatraa and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports-news-Dreamhack%2C-Twitch%2C-Sinatraa-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports+news+Dreamhack%2C+Twitch%2C+Sinatraa+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1120,
        name: 'Esports news LDLC, Rocket League, BBC and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports-news-LDLC%2C-Rocket-League%2C-BBC-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports+news+LDLC%2C+Rocket+League%2C+BBC+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1121,
        name: 'Esports news LEC Winners, TSM, FPX and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports-news-LEC-Winners%2C-TSM%2C-FPX-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports+news+LEC+Winners%2C+TSM%2C+FPX+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1122,
        name: 'Esports news Poke\'mon, ESL One, Popular events and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports-news-Poke\'mon%2C-ESL-One%2C-Popular-events-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports+news+Poke\'mon%2C+ESL+One%2C+Popular+events+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1123,
        name: 'Gaming Industry Updates EVO, Summer Game Fest, GDC and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming-Industry-Updates-EVO%2C-Summer-Game-Fest%2C-GDC-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming+Industry+Updates+EVO%2C+Summer+Game+Fest%2C+GDC+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1124,
        name: 'Gaming Industry Updates Germany, Travis Scott, LoL MSI and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming-Industry-Updates-Germany%2C-Travis-Scott%2C-LoL-MSI-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming+Industry+Updates+Germany%2C+Travis+Scott%2C+LoL+MSI+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1125,
        name: 'Gaming Industry Updates Ubisoft, Switch, Capcom and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming-Industry-Updates-Ubisoft%2C-Switch%2C-Capcom-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming+Industry+Updates+Ubisoft%2C+Switch%2C+Capcom+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1126,
        name: 'Gaming Industry Updates- Microsoft, Playstation, big budgets & more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming-Industry-Updates--Microsoft%2C-Playstation%2C-big-budgets-%26-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming+Industry+Updates-+Microsoft%2C+Playstation%2C+big+budgets+%26+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1127,
        name: 'Gaming- LEC Spring, Gamescom and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming--LEC-Spring%2C-Gamescom-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming-+LEC+Spring%2C+Gamescom+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1128,
        name: 'Mobile gaming news Crash Bandicoot, Legends of Runeterra and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile-gaming-news-Crash-Bandicoot%2C-Legends-of-Runeterra-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile+gaming+news+Crash+Bandicoot%2C+Legends+of+Runeterra+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1129,
        name: 'Mobile gaming news Red Dot, Spongebob, Sonic and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile-gaming-news-Red-Dot%2C-Spongebob%2C-Sonic-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile+gaming+news+Red+Dot%2C+Spongebob%2C+Sonic+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1130,
        name: 'Mobile Gaming News Surviving Titan, Endurance and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile-Gaming-News-Surviving-Titan%2C-Endurance-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile+Gaming+News+Surviving+Titan%2C+Endurance+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1131,
        name: 'Mobile gaming news- Rebel Cops, Grid Autosport and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile-gaming-news--Rebel-Cops%2C-Grid-Autosport-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile+gaming+news-+Rebel+Cops%2C+Grid+Autosport+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1132,
        name: 'Mobile Gaming News- Valorant, Forza Street and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile-Gaming-News--Valorant%2C-Forza-Street-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile+Gaming+News-+Valorant%2C+Forza+Street+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1133,
        name: 'Remarkable Gamers- Esports pro Ant1ka is taking CS-GO by storm',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Remarkable-Gamers--Esports-pro-Ant1ka-is-taking-CS-GO-by-storm.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Remarkable+Gamers-+Esports+pro+Ant1ka+is+taking+CS-GO+by+storm.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1134,
        name: 'This Week in Gaming Assassin\'s Creed, Battlefield, Stadia and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/This-Week-in-Gaming-Assassin\'s-Creed%2C-Battlefield%2C-Stadia-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/This+Week+in+Gaming+Assassin\'s+Creed%2C+Battlefield%2C+Stadia+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1135,
        name: 'This Week in Gaming Eco Sims, Apex Legends, Star Wars and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/This-Week-in-Gaming-Eco-Sims%2C-Apex-Legends%2C-Star-Wars-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/This+Week+in+Gaming+Eco+Sims%2C+Apex+Legends%2C+Star+Wars+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1136,
        name: 'This Week in Gaming PS5 graphics, F1 2020, Twitch and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/This-Week-in-Gaming-PS5-graphics%2C-F1-2020%2C-Twitch-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/This+Week+in+Gaming+PS5+graphics%2C+F1+2020%2C+Twitch+and+more.mp4',
        filename: '' } ]
    },
    {
        "id":32,
        "contents":4,
        "name": {
            "en": "Animal",
            "ee": "Loomad",
            "lv":"Dzīvnieks",
            "lt":"Gyvūnas",
            "sr":"Анимал",
            "el":"Ζώα",
            "de":"Tiere",
            "fr":"Animal",
            "it":"Animale",
            "cs":"Zvíře",
            "es": "Animal",
            "pt": "Animal"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1137,
        name: 'How are countries dealing with rising domestic violence cases',
        preview: 'https://cdn.mobiotv.com/bidiotv/Animals/How-are-countries-dealing-with-rising-domestic-violence-cases.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Animals/How+are+countries+dealing+with+rising+domestic+violence+cases.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1138,
        name: 'My Dream Job- A dash of bow tie dapperness for shelter dogs',
        preview: 'https://cdn.mobiotv.com/bidiotv/Animals/My-Dream-Job-A-dash-of-bow-tie-dapperness-for-shelter-dogs.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Animals/My+Dream+Job-+A+dash+of+bow+tie+dapperness+for+shelter+dogs.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1139,
        name: 'Pets with Professions- Max was elected Mayor of a city... and he\'s a dog',
        preview: 'https://cdn.mobiotv.com/bidiotv/Animals/Pets-with-Professions-Max-was-elected-Mayor-of-a-city...-and-he\'s-a-dog.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Animals/Pets+with+Professions-+Max+was+elected+Mayor+of+a+city...+and+he\'s+a+dog.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1140,
        name: 'This dog\'s got skills when it comes to stuffing tennis balls in his mouth',
        preview: 'https://cdn.mobiotv.com/bidiotv/Animals/This-dog\'s-got-skills-when-it-comes-to-stuffing-tennis-balls-in-his-mouth.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Animals/This+dog\'s+got+skills+when+it+comes+to+stuffing+tennis+balls+in+his+mouth.mp4',
        filename: '' } ]
    },
    {
        "id":33,
        "contents":2,
        "name": {
            "en": "Ancient",
            "ee": "Antiik",
            "lv":"Senatne",
            "lt":"Senovės",
            "sr":"Анциент",
            "el":"Αρχαία",
            "de":"Antike",
            "fr":"Ancienne",
            "it":"Antica",
            "cs":"Starověké",
            "es": "Antiguo",
            "pt": "Antigo"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1141,
        name: 'Beng-Mealea-An-ancient-temple-reclaimed-by-nature',
        preview: 'https://cdn.mobiotv.com/bidiotv/Ancient/Beng-Mealea-An-ancient-temple-reclaimed-by-nature.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Ancient/Beng+Mealea+An+ancient+temple+reclaimed+by+nature.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1142,
        name: 'These countries should be really proud of their leaders right now',
        preview: 'https://cdn.mobiotv.com/bidiotv/Ancient/These-countries-should-be-really-proud-of-their-leaders-right-now.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Ancient/These+countries+should+be+really+proud+of+their+leaders+right+now.mp4',
        filename: '' } ]
    },
    {
        "id":34,
        "contents":4,
        "name": {
            "en": "Business",
            "ee": "Äri",
            "lv":"Bizness",
            "lt":"Verslas",
            "sr":"Посао",
            "el":"Επιχειρήσεις",
            "de":"Wirtschaft",
            "fr":"Entreprise",
            "it":"Attività commerciale",
            "cs":"Byznys",
            "es": "Empresa",
            "pt": "Negócios"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1143,
        name: 'Are they hiring 5 industries doing better than ever before',
        preview: 'https://cdn.mobiotv.com/bidiotv/Business/Are-they-hiring-5-industries-doing-better-than-ever-before.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Business/Are+they+hiring+5+industries+doing+better+than+ever+before.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1144,
        name: 'How the West Bank took a mask shortage into their own hands',
        preview: 'https://cdn.mobiotv.com/bidiotv/Business/How-the-West-Bank-took-a-mask-shortage-into-their-own-hands.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Business/How+the+West+Bank+took+a+mask+shortage+into+their+own+hands.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1145,
        name: 'University students are filing lawsuits over tuition fees',
        preview: 'https://cdn.mobiotv.com/bidiotv/Business/University-students-are-filing-lawsuits-over-tuition-fees.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Business/University+students+are+filing+lawsuits+over+tuition+fees.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1146,
        name: '"Why the ""5G Conspiracy"" is harmful and making some men money"',
        preview: 'https://cdn.mobiotv.com/bidiotv/Business/Why-the-%225G-Conspiracy%22-is-harmful-(and-making-some-men-money).jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Business/Why+the+%225G+Conspiracy%22+is+harmful+and+making+some+men+money.mp4',
        filename: '' } ]
    },
    {
        "id":35,
        "contents":2,
        "name": {
            "en": "Beat The Heat",
            "ee": "Suvekuumus",
            "lv":"Pārspēt siltumu",
            "lt":"Nugalėk šilumą",
            "sr":"Беат Тхе Хеат",
            "el":"Δροσιστείτε",
            "de":"Die Hitze besiegen",
            "fr":"Combattre la chaleur",
            "it":"Batte il cuore",
            "cs":"Poraz teplo",
            "es": "Lucha contra el calor",
            "pt": "Derrote o Calor"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1147,
        name: 'Beat the heat with blue lagoon cocktail popsicles',
        preview: 'https://cdn.mobiotv.com/bidiotv/Beat+the+Heat/Beat-the-heat-with-blue-lagoon-cocktail-popsicles.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Beat+the+Heat/Beat+the+heat+with+blue+lagoon+cocktail+popsicles.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1148,
        name: 'Beat the heat with cuervo sangria popsicles',
        preview: 'https://cdn.mobiotv.com/bidiotv/Beat+the+Heat/Beat-the-heat-with-cuervo-sangria-popsicles.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Beat+the+Heat/Beat+the+heat+with+cuervo+sangria+popsicles.mp4',
        filename: '' } ]
    },
    {
        "id":36,
        "contents":1,
        "name": {
            "en": "Morality",
            "ee": "Kõlblus",
            "lv":"Morāle",
            "lt":"Moralė",
            "sr":"Морал",
            "el":"Ηθική",
            "de":"Moral",
            "fr":"Moralité",
            "it":"Moralità",
            "cs":"Morálka",
            "es": "Moralidad",
            "pt": "Moralidade"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1149,
        name: 'Could humanity be one cyber suit away from immortality',
        preview: 'https://cdn.mobiotv.com/bidiotv/Morality/Could-humanity-be-one-cyber-suit-away-from-immortality.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Morality/Could+humanity+be+one+cyber+suit+away+from+immortality.mp4',
        filename: '' } ]
    },
    {
        "id":37,
        "contents":1,
        "name": {
            "en": "Racing",
            "ee": "Võidusõit",
            "lv":"Sacīkstes",
            "lt":"Lenktynės",
            "sr":"Тркање",
            "el":"Ιπποδρομίες",
            "de":"Rennen",
            "fr":"Racing",
            "it":"Da corsa",
            "cs":"Závodění",
            "es": "Carreras",
            "pt": "Corrida"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1150,
        name: 'Mercedes F1 ditches races for life-saving medical devices',
        preview: 'https://cdn.mobiotv.com/bidiotv/Racing/Mercedes-F1-ditches-races-for-life-saving-medical-devices.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Racing/Mercedes+F1+ditches+races+for+life-saving+medical+devices.mp4',
        filename: '' } ]
    },
    {
        "id":38,
        "contents":1,
        "name": {
            "en": "Science",
            "ee": "Teadus",
            "lv":"Zinātne",
            "lt":"Mokslas",
            "sr":"Наука",
            "el":"Επιστήμη",
            "de":"Wissenschaft",
            "fr":"Science",
            "it":"Scienza",
            "cs":"Věda",
            "es": "Ciencia",
            "pt": "Ciência"
        },
        "videos": [ { duration: 'Watch Now',
        id: 1151,
        name: 'Scientists have \'engineered\' an enzyme that devours plastic',
        preview: 'https://cdn.mobiotv.com/bidiotv/Science/Scientists-have-\'engineered\'-an-enzyme-that-devours-plastic.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Science/Scientists+have+\'engineered\'+an+enzyme+that+devours+plastic.mp4',
        filename: '' },
       ]
    },
    {
        "id":1,
        "contents":9,
        "name": {
            "en": "Inspiration",
            "ee": "Inspiratsioon",
            "be": "Inspiratie",
            "id": "Inspiration",
            "it": "Ispirazione",
            "se": "Inspiration",
            "no": "Inspiration",
            "fr": "Inspiration",
            "lv":"Iedvesma",
            "lt":"Įkvėpimas",
            "sr":"Инспирација",
            "el":"Έμπνευση",
            "de":"Inspiration",
            "cs":"Inspirace",
            "es": "Inspiración",
            "pt": "Inspiração"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 906,
                "name": "An Influencer's Calling 'Everyone had to accept me when I accepted myself'",
                "preview": "https://cdn.mobiotv.com/bidiotv/Inspiration/An+Influencer's+Calling+'Everyone+had+to+accept+me+when+I+accepted+myself'.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Inspiration/An+Influencer's+Calling+'Everyone+had+to+accept+me+when+I+accepted+myself'.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 907,
                "name": "Crazy Cravings 'When I'm behind my mask, I'm basically someone new'",
                "preview": "https://cdn.mobiotv.com/bidiotv/Inspiration/Crazy+Cravings+'When+I'm+behind+my+mask%2C+I'm+basically+someone+new'.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Inspiration/Crazy+Cravings+'When+I'm+behind+my+mask%2C+I'm+basically+someone+new'.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 908,
                "name": "I'm a Celebrity Pet Luna is a prickly up-and-comer",
                "preview": "https://cdn.mobiotv.com/bidiotv/Inspiration/I'm+a+Celebrity+Pet+Luna+is+a+prickly+up-and-comer.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Inspiration/I'm+a+Celebrity+Pet!+Luna+is+a+prickly+up-and-comer.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 909,
                "name": "Inspire in a minute The supermodel discovered at 60",
                "preview": "https://cdn.mobiotv.com/bidiotv/Inspiration/Inspire+in+a+minute+The+supermodel+discovered+at+60.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Inspiration/Inspire+in+a+minute+The+supermodel+discovered+at+60.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 910,
                "name": "Inspire in a Minute Tim brought sexy back for the Lumberjack",
                "preview": "https://cdn.mobiotv.com/bidiotv/Inspiration/Inspire+in+a+Minute+Tim+brought+sexy+back+for+the+Lumberjack.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Inspiration/Inspire+in+a+Minute+Tim+brought+sexy+back+for+the+Lumberjack.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 911,
                "name": "My Cool School Camilla's studying the trapeze",
                "preview": "https://cdn.mobiotv.com/bidiotv/Inspiration/My+Cool+School+Camilla's+studying+the+trapeze.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Inspiration/My+Cool+School+Camilla's+studying+the+trapeze.mp4",
                "filename":"",
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 912,
            //     "name": "My Social Media Activism Reminding others they aren't alone",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Inspiration/My+Social+Media+Activism+It's+time+for+everyone+to+%23FillTheBottle.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/bidiotv/Inspiration/My+Social+Media+Activism+It's+time+for+everyone+to+%23FillTheBottle.mp4",
            //     "filename":"",
            // },
            {
                "duration": "Watch Now",
                "id": 913,
                "name": "The pilots flying a restored WWII plane around the world",
                "preview": "https://cdn.mobiotv.com/bidiotv/Inspiration/The+pilots+flying+a+restored+WWII+plane+around+the+world.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Inspiration/The+pilots+flying+a+restored+WWII+plane+around+the+world.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 914,
                "name": "Young CEO 'When I look at a camera, I see power in me & I see greatness",
                "preview": "https://cdn.mobiotv.com/bidiotv/Inspiration/Young+CEO+'When+I+look+at+a+camera%2C+I+see+power+in+me+%26+I+see+greatness'.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Inspiration/Young+CEO+'When+I+look+at+a+camera%2C+I+see+power+in+me+%26+I+see+greatness'.mp4",
                "filename":"",
            }
        ]
    },
    {
        "id":2,
        "contents":5,
        "name": {
            "en": "Into Nature",
            "ee": "Loodusesse",
            "be": "Natuur",
            "id": "Natur",
            "it": "Natura",
            "se": "Natur",
            "no": "Into Nature",
            "fr": "Dans la nature",
            "lv":"Dabā",
            "lt":"Į gamtą",
            "sr":"У природу",
            "el":"Στη Φύση",
            "de":"In die Natur",
            "cs":"Do přírody",
            "es": "En la naturaleza",
            "pt": "Na Natureza"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 915,
                "name": "City Innovations The higher you go, the greener it gets",
                "preview": "https://cdn.mobiotv.com/bidiotv/Into+Nature/City+Innovations+The+higher+you+go%2C+the+greener+it+gets.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Into+Nature/City+Innovations+The+higher+you+go%2C+the+greener+it+gets.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 916,
                "name": "Green Heroes The urban experience just got a sustainable upgrade",
                "preview": "https://cdn.mobiotv.com/bidiotv/Into+Nature/Green+Heroes+The+urban+experience+just+got+a+sustainable+upgrade.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Into+Nature/Green+Heroes+The+urban+experience+just+got+a+sustainable+upgrade.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 917,
                "name": "Inspire in a Minute From bullied bug hunter to kid author",
                "preview": "https://cdn.mobiotv.com/bidiotv/Into+Nature/Inspire+in+a+Minute+From+bullied+bug+hunter+to+kid+author.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Into+Nature/Inspire+in+a+Minute+From+bullied+bug+hunter+to+kid+author.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 918,
                "name": "Sights with Heights Ghana’s national park canopy walk",
                "preview": "https://cdn.mobiotv.com/bidiotv/Into+Nature/Sights+with+Heights+Ghana%E2%80%99s+national+park+canopy+walk.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Into+Nature/Sights+with+Heights+Ghana%E2%80%99s+national+park+canopy+walk.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 919,
                "name": "Sights with Heights The cliff side sanctuary between heaven and earth",
                "preview": "https://cdn.mobiotv.com/bidiotv/Into+Nature/Sights+with+Heights+The+cliff+side+sanctuary+between+heaven+and+earth.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Into+Nature/Sights+with+Heights+The+cliff+side+sanctuary+between+heaven+and+earth.mp4",
                "filename":"",
            }
        ]
    },
    {
        "id":3,
        "contents":19,
        "name": {
            "en": "Political & Activism",
            "ee": "Poliitika ja aktivism",
            "be": "Politiek activisme",
            "id": "Politisk & aktivism",
            "it": "Politico e attivismo",
            "se": "Politisk & aktivism",
            "no": "Political & Activism",
            "fr": "Politique et activisme",
            "lv":"Politiska un aktīvisms",
            "lt":"Politika ir aktyvizmas",
            "sr":"Политички и активизам",
            "el":"Πολιτικά & ακτιβισμός",
            "de":"Politik & Aktivismus",
            "cs":"Politika a aktivismus",
            "es": "Política y activismo",
            "pt": "Política e Ativismo"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 920,
                "name": "A place to call home for abandoned dogs",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/A+place+to+call+home+for+abandoned+dogs.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/A+place+to+call+home+for+abandoned+dogs.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 921,
                "name": "Barry the bee whisperer’s most important fight yet",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Barry+the+bee+whisperer%E2%80%99s+most+important+fight+yet.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Barry+the+bee+whisperer%E2%80%99s+most+important+fight+yet.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 922,
                "name": "CEO activism is on the rise",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/CEO+activism+is+on+the+rise.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/CEO+activism+is+on+the+rise.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 923,
                "name": "Indigenous Heroes Nigeria's Elijah is seeking legal justice for his people",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Indigenous+Heroes+Nigeria's+Elijah+is+seeking+legal+justice+for+his+people.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Indigenous+Heroes+Nigeria's+Elijah+is+seeking+legal+justice+for+his+people.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 924,
                "name": "Indonesia to build a new capital due to climate change",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Indonesia+to+build+a+new+capital+due+to+climate+change.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Indonesia+to+build+a+new+capital+due+to+climate+change.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 925,
                "name": "Inspire in a Minute Breaking Borders is a tour you have to go on",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+Breaking+Borders+is+a+tour+you+have+to+go+on.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+Breaking+Borders+is+a+tour+you+have+to+go+on.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 926,
                "name": "Inspire in a Minute Fighting menstrual stigma in Nepal",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+Fighting+menstrual+stigma+in+Nepal.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+Fighting+menstrual+stigma+in+Nepal.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 927,
                "name": "Inspire in a Minute Helping kids fight back & get better",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+Helping+kids+fight+back+%26+get+better.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+Helping+kids+fight+back+%26+get+better.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 928,
                "name": "Inspire in a Minute War Workout Warriors",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+War+Workout+Warriors.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Inspire+in+a+Minute+War+Workout+Warriors.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 929,
                "name": "LGBTQ+ Newcomers 'I remained concrete about my identity'",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/LGBTQ%2B+Newcomers+'I+remained+concrete+about+my+identity'.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/LGBTQ%2B+Newcomers+'I+remained+concrete+about+my+identity'.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 930,
                "name": "More than half of world’s forest wildlife disappeared",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Indonesia+to+build+a+new+capital+due+to+climate+change.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Indonesia+to+build+a+new+capital+due+to+climate+change.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 931,
                "name": "My Social Media Activism It's time for everyone to #FillTheBottle",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/My+Social+Media+Activism+It's+time+for+everyone+to+%23FillTheBottle.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/My+Social+Media+Activism+It's+time+for+everyone+to+%23FillTheBottle.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 932,
                "name": "Peace Builders Closing the cycle of violence",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Peace+Builders+Closing+the+cycle+of+violence.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Peace+Builders+Closing+the+cycle+of+violence.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 933,
                "name": "Peace Builders The Art of Peaceful Resistance",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Peace+Builders+The+Art+of+Peaceful+Resistance.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Peace+Builders+The+Art+of+Peaceful+Resistance.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 935,
                "name": "Peace Builders The uniting factor that's bringing people together",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Peace+Builders+The+uniting+factor+that's+bringing+people+together.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Peace+Builders+The+uniting+factor+that's+bringing+people+together.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 936,
                "name": "Rebecca Minkoff pays tribute to breastfeeding working moms at NYFW",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Rebecca+Minkoff+pays+tribute+to+breastfeeding+working+moms+at+NYFW.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/Rebecca+Minkoff+pays+tribute+to+breastfeeding+working+moms+at+NYFW.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 937,
                "name": "The “virginity test” still happens in these countries",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/The+%E2%80%9Cvirginity+test%E2%80%9D+still+happens+in+these+countries.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/The+%E2%80%9Cvirginity+test%E2%80%9D+still+happens+in+these+countries.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 938,
                "name": "The results are in, Tokyo is the safest city in the world",
                "preview": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/The+results+are+in%2C+Tokyo+is+the+safest+city+in+the+world.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Political+%26+Activism/The+results+are+in%2C+Tokyo+is+the+safest+city+in+the+world!.mp4",
                "filename":"",
            }
        ]
    },
    {
        "id":4,
        "contents":5,
        "name": {
            "en": "Travel",
            "ee": "Reisimine",
            "be": "Reizen",
            "id": "Resa",
            "it": "Viaggio",
            "se": "Resa",
            "no": "Travel",
            "fr": "Voyages",
            "lv":"Ceļošana",
            "lt":"Kelionės",
            "sr":"Путовањ",
            "el":"Ταξίδι",
            "de":"Reisen",
            "cs":"Cestování",
            "es": "Viaje",
            "pt": "Viagens"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 939,
                "name": "Amazing Waterfalls Zambia's jaw-dropping natural wonder",
                "preview": "https://cdn.mobiotv.com/bidiotv/Travel/Amazing+Waterfalls+Zambia's+jaw-dropping+natural+wonder.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Travel/Amazing+Waterfalls+Zambia's+jaw-dropping+natural+wonder.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 940,
                "name": "Fairy tale dream spots The prettiest village in Andalucía",
                "preview": "https://cdn.mobiotv.com/bidiotv/Travel/Fairy+Tale+Dream+Spots+The+sinking+castle+of+Scaligera.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Travel/Fairy+Tale+Dream+Spots+The+sinking+castle+of+Scaligera.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 941,
                "name": "Fairy Tale Dream Spots The sinking castle of Scaligera",
                "preview": "https://cdn.mobiotv.com/bidiotv/Travel/Fairy+tale+dream+spots+The+prettiest+village+in+Andaluci%CC%81a.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Travel/Fairy+tale+dream+spots+The+prettiest+village+in+Andaluci%CC%81a.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 942,
                "name": "Medellín is the backpacking spot you've been looking for",
                "preview": "https://cdn.mobiotv.com/bidiotv/Travel/Medelli%CC%81n+is+the+backpacking+spot+you've+been+looking+for.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Travel/Medelli%CC%81n+is+the+backpacking+spot+you've+been+looking+for.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 943,
                "name": "Sights with Heights The narrow bridges of Caminito del Rey",
                "preview": "https://cdn.mobiotv.com/bidiotv/Travel/Sights+with+Heights+The+narrow+bridges+of+Caminito+del+Rey.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Travel/Sights+with+Heights+The+narrow+bridges+of+Caminito+del+Rey.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 944,
                "name": "This Dutch parade takes flower power to the next level",
                "preview": "https://cdn.mobiotv.com/bidiotv/Travel/This+Dutch+parade+takes+flower+power+to+the+next+level.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Travel/This+Dutch+parade+takes+flower+power+to+the+next+level.mp4",
                "filename":"",
            }
        ]
    },
    {
        "id": 5,
        "contents": 3,
        "name": {
            "en": "Foodbuzz",
            "ee": "Toit",
            "be": "Foodbuzz",
            "id": "Foodbuzz",
            "it": "Foodbuzz",
            "se": "Mat",
            "no": "Foodbuzz",
            "fr": "Cuisine qui fait le buzz",
            "lv":'Ēdiens',
            "lt":"Maistas",
            "sr":"Фоодбуз",
            "el":"Φαγητό",
            "de":"Foodbuzz",
            "cs":"Foodbuzz",
            "es": "Foodbuzz",
            "pt": "Comilância"
        },
        "videos": [
            {
                "duration": "Watch Now",
                "id": 901,
                "name": "Insta Restaurant We could all use a bit more pink in our lives",
                "preview": "https://cdn.mobiotv.com/bidiotv/Foodbuzz/Insta+Restaurant+We+could+all+use+a+bit+more+pink+in+our+lives.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Foodbuzz/Insta+Restaurant+We+could+all+use+a+bit+more+pink+in+our+lives.mp4",
                "filename": "",
            },
            {
                "duration": "Watch Now",
                "id": 902,
                "name": "KFC is testing meatless chicken wings and nuggets",
                "preview": "https://cdn.mobiotv.com/bidiotv/Foodbuzz/KFC+is+testing+meatless+chicken+wings+and+nuggets.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Foodbuzz/KFC+is+testing+meatless+chicken+wings+and+nuggets.mp4",
                "filename": "",
            },
            {
                "duration": "Watch Now",
                "id": 903,
                "name": "Turning leftover bread into panzanella & bruschetta caprese",
                "preview": "https://cdn.mobiotv.com/bidiotv/Foodbuzz/Turning+leftover+bread+into+panzanella+%26+bruschetta+caprese.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Foodbuzz/Turning+leftover+bread+into+panzanella+%26+bruschetta+caprese.mp4",
                "filename": "",
            },
            {
                "duration": "Watch Now",
                "id": 805,
                "name": "Salsas for Sunny Days Spicy mango salsa",
                "preview": "https://cdn.mobiotv.com/bidiotv/Tutorials/Salsas+for+Sunny+Days+Spicy+mango+salsa.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Tutorials/Salsas+for+Sunny+Days+Spicy+mango+salsa.mp4",
                "filename": "",
            },
            {
                "duration": "Watch Now",
                "id": 806,
                "name": "Vegan Ice Cream Avocado Banana",
                "preview": "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Avocado+Banana.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Avocado+Banana.mp4",
                "filename": "",
            },
            {
                "duration": "Watch Now",
                "id": 807,
                "name": "Vegan Ice Cream Banana Matcha",
                "preview": "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Banana+Matcha.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Banana+Matcha.mp4",
                "filename": "",
            },
            {
                "duration": "Watch Now",
                "id": 808,
                "name": "Vegan Ice Cream Coconut Fusion",
                "preview": "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Coconut+Fusion.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Coconut+Fusion.mp4",
                "filename": "",
            },
            {
                "duration": "Watch Now",
                "id": 809,
                "name": "Vegan Ice Cream Fresh Fruit Popsicles",
                "preview": "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Fresh+Fruit+Popsicles.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Fresh+Fruit+Popsicles.mp4",
                "filename": "",
            },
            {
                "duration": "Watch Now",
                "id": 810,
                "name": "Vegan Ice Cream Pineapple Mint Lime",
                "preview": "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Pineapple+Mint+Lime.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Tutorials/Vegan+Ice+Cream+Pineapple+Mint+Lime.mp4",
                "filename": "",
            }
        ]
    },
    {
        "id": 6,
        "contents": 2,
        "name": {
            "en": "Health and Nutrition",
            "ee": "Tervis ja toitumine",
            "be": "Gezondheid & Voeding",
            "id": "Hälsa och näring",
            "it": "Salute e Nutrizione",
            "se": " Hälsa och kost",
            "no": "Health and Nutrition",
            "fr": "Santé et nutrition",
            "lv":"Veselība un uzturs",
            "lt":"Sveikata ir mityba",
            "sr":"Здравље и исхрана",
            "el":"Υγεία και Διατροφή",
            "de":"Gesundheit und Ernährung",
            "cs":"Zdraví a výživa",
            "es": "Salud y nutrición",
            "pt": "Saúde e Nutrição"
        },
        "videos": [
            {
                "duration": "Watch Now",
                "id": 904,
                "name": "Brain implants are closer than you might think...",
                "preview": "https://cdn.mobiotv.com/bidiotv/Health+and+Nutrition/Brain+implants+are+closer+than+you+might+think....jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Health+and+Nutrition/Brain+implants+are+closer+than+you+might+think....mp4",
                "filename": "",
            },
            {
                "duration": "Watch Now",
                "id": 905,
                "name": "Thanks, Chameleons Humans might get color-changing skin",
                "preview": "https://cdn.mobiotv.com/bidiotv/Health+and+Nutrition/Thanks%2C+Chameleons+Humans+might+get+color-changing+skin.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Health+and+Nutrition/Thanks%2C+Chameleons+Humans+might+get+color-changing+skin.mp4",
                "filename": "",
            }
        ]
    },
    {
        "id": 7,
        "contents": 24,
        "name": {
            "en": "Fitness",
            "be": "Fitness",
            "id": "Kebugaran",
            "it": "Fitness",
            "se": "Kondition",
            "no": "Fitness",
            "fr": "Fitness",
            "ee": "Kehaline vorm",
            "lv":"Fitness",
            "lt":"Fitnesas",
            "sr":"Фитнесс",
            "el":"Καταλληλότητα",
            "de":"Fitness",
            "cs":"Fitness",
            "es": "Fitness",
            "pt": "Fitness"
        },
        "videos": [
            {
                "duration": "Watch Now",
                "id": 1,
                "name": "Arm and Leg Raise",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Arm+and+Leg+Raise.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fitness/Arm+and+Leg+Raise.mp4",
                "filename":"bidiotv/Fitness/Arm+and+Leg+Raise.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 2,
                "name": "Attack and Defense",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Attack+and+Defense.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fitness/Attack+and+Defense.mp4",
                "filename":"bidiotv/Fitness/Attack+and+Defense.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 3,
                "name": "Condition training",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Condition+training.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fitness/Condition+training.mp4",
                "filename":"bidiotv/Fitness/Condition+training.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 4,
                "name": "Core Strength",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Core+strength.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fitness/Core+strength.mp4",
                "filename":"bidiotv/Fitness/Core+strength.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 5,
                "name": "Lunges",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Lunges.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fitness/Lunges.mp4",
                "filename":"bidiotv/Fitness/Lunges.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 6,
                "name": "Punch Bag",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Punch+Bag.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fitness/Punch+Bag.mp4",
                "filename":"bidiotv/Fitness/Punch+Bag.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 7,
                "name": "Push Ups",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Push+Ups.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fitness/Push+Ups.mp4",
                "filename":"bidiotv/Fitness/Push+Ups.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 8,
                "name": "Russian Kicks",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Russian+Kicks.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fitness/Russian+Kicks.mp4",
                "filename":"bidiotv/Fitness/Russian+Kicks.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 9,
                "name": "Shadow Boxing",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Shadowboxing.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fitness/Shadowboxing.mp4",
                "filename":"bidiotv/Fitness/Shadowboxing.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 10,
                "name": "Sit Ups",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Sit+Ups.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fitness/Sit+Ups.mp4",
                "filename":"bidiotv/Fitness/Sit+Ups.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 11,
                "name": "Stretching",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Stretching.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fitness/Stretching.mp4",
                "filename":"bidiotv/Fitness/Stretching.mp4",               
            },
            {
                "duration": "Watch Now",
                "id": 12,
                "name": "The Plank",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/The+Plank.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fitness/The+Plank.mp4",
                "filename":"bidiotv/Fitness/The+Plank.mp4",

            },
            {
                "duration": "Watch Now",
                "id": 13,
                "name": "Tricep Dips",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fitness/Tricep+Dips.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fitness/Tricep+Dips.mp4",
                "filename":"bidiotv/Fitness/Tricep+Dips.mp4",
            },
        ]
    },
    {
        "id": 8,
        "contents": 24,
        "name": {
            "en": "Top Cars",
            "be": "Top Auto's",
            "id": "Mobil Terbaik",
            "it": "Le migliori auto",
            "se": "Bästa bilarna",
            "no": "Top Cars",
            "fr": "Voitures haut-de-gamme",
            "ee": "Tippautod",
            "lv":"Labākās automašīnas",
            "lt":"Top automobiliai",
            "sr":"Топ Царс",
            "el":"Κορυφαία αυτοκίνητα",
            "de":"Top-Autos",
            "cs":"Nejlepší auta",
            "es": "Los mejores coches",
            "pt": "Melhores Carros"
        },
        "videos": [
            {
                "duration": "Watch Now",
                "id": 24,
                "name": "2016 Chevrolet Camaro SS",
                "preview": "https://cdn.mobiotv.com/bidiotv/Top+Gear/2016+Chevrolet+Camaro+SS.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Top+Gear/2016+Chevrolet+Camaro+SS.mp4",
                "filename":"bidiotv/Top+Gear/2016+Chevrolet+Camaro+SS.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 25,
                "name": "2016 Ford Mustang Fastback",
                "preview": "https://cdn.mobiotv.com/bidiotv/Top+Gear/2016+Ford+Mustang+Fastback.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Top+Gear/2016+Ford+Mustang+Fastback.mp4",
                "filename":"bidiotv/Top+Gear/2016+Ford+Mustang+Fastback.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 26,
                "name": "2016 Ford Mustang GT4",
                "preview": "https://cdn.mobiotv.com/bidiotv/Top+Gear/2016+Ford+Mustang+GT4.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Top+Gear/2016+Ford+Mustang+GT4.mp4",
                "filename":"bidiotv/Top+Gear/2016+Ford+Mustang+GT4.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 27,
                "name": "2016 Toyota Prius G Racing Car",
                "preview": "https://cdn.mobiotv.com/bidiotv/Top+Gear/2016+Toyota+Xtreme+Corolla.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Top+Gear/2016+Toyota+Prius+G+Racing+Car.mp4",
                "filename":"bidiotv/Top+Gear/2016+Toyota+Prius+G+Racing+Car.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 28,
                "name": "2016 Toyota Xtreme Corolla",
                "preview": "https://cdn.mobiotv.com/bidiotv/Top+Gear/2016+Toyota+Prius+G+Racing+Car.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Top+Gear/2016+Toyota+Xtreme+Corolla.mp4",
                "filename":"bidiotv/Top+Gear/2016+Toyota+Xtreme+Corolla.mp4",
            },
        ]
    },
    {
        "id": 9,
        "contents": 24,
        "name": {
            "en": "Fashion & Beauty",
            "be": "Mode & Schoonheid",
            "id": "Fashion & Kecantikan",
            "it": "Moda e bellezza",
            "se": "Mode & skönhet",
            "no": "Mote og skjønnhet",
            "fr": "Mode et beauté",
            "ee": "Mood ja ilu",
            "lv":"Mode un skaistums",
            "lt":"Mada ir grožis",
            "sr":"Мода и лепота",
            "el":"Μόδα & Ομορφιά",
            "de":"Mode & Schönheit",
            "cs":"Móda a krása",
            "es": "Moda y belleza",
            "pt": "Moda e Beleza"
        },
        "videos": [
            {
                "duration": "Watch Now",
                "id": 29,
                "name": "Glamorous Touch",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Glamorous+Touch.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fashion+%26+Beauty/Glamorous+Touch.mp4",
                "filename":"bidiotv/Fashion+%26+Beauty/Glamorous+Touch.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 30,
                "name": "Lips Glamorous Red",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Lips+Glamorous+Red.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fashion+%26+Beauty/Lips+Glamorous+Red.mp4",
                "filename":"bidiotv/Fashion+%26+Beauty/Lips+Glamorous+Red.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 31,
                "name": "Lips Natural",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Lips+Natural.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fashion+%26+Beauty/Lips+Natural.mp4",
                "filename":"bidiotv/Fashion+%26+Beauty/Lips+Natural.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 32,
                "name": "Lips Sparkling and Full",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Lips+Sparkling+and+Full.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fashion+%26+Beauty/Lips+Sparkling+and+Full.mp4",
                "filename":"bidiotv/Fashion+%26+Beauty/Lips+Sparkling+and+Full.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 33,
                "name": "Make-Up Blush",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make-Up+Blush.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fashion+%26+Beauty/Make-Up+Blush.mp4",
                "filename":"bidiotv/Fashion+%26+Beauty/Make-Up+Blush.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 34,
                "name": "Make-Up Bronzer",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make-Up+Bronzer.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fashion+%26+Beauty/Make-Up+Bronzer.mp4",
                "filename":"bidiotv/Fashion+%26+Beauty/Make-Up+Bronzer.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 35,
                "name": "Make-Up Concealer",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make-Up+Concealer.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fashion+%26+Beauty/Make-Up+Concealer.mp4",
                "filename":"bidiotv/Fashion+%26+Beauty/Make-Up+Concealer.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 36,
                "name": "Make-Up Eyebrows",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make-Up+Eyebrows.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fashion+%26+Beauty/Make-Up+Eyebrows.mp4",
                "filename":"bidiotv/Fashion+%26+Beauty/Make-Up+Eyebrows.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 37,
                "name": "Make-Up Foundation",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make-Up+Foundation.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fashion+%26+Beauty/Make-Up+Foundation.mp4",
                "filename":"bidiotv/Fashion+%26+Beauty/Make-Up+Foundation.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 38,
                "name": "Smokey Eyes",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Smokey+Eyes.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fashion+%26+Beauty/Smokey+Eyes.mp4",
                "filename":"bidiotv/Fashion+%26+Beauty/Smokey+Eyes.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 39,
                "name": "Sparkling Eyes",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Sparkling+Eyes.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Fashion+%26+Beauty/Sparkling+Eyes.mp4",
                "filename":"bidiotv/Fashion+%26+Beauty/Sparkling+Eyes.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 140,
                "name": "5 Make up tips and Tricks for you",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/5+Make+up+tips+and+Tricks+for+you.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/5+Make+up+tips+and+Tricks+for+you.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 141,
                "name": "7 Make up tips and tricks for flawless skin",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/7+Make+up+tips+and+tricks+for+flawless+skin.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/7+Make+up+tips+and+tricks+for+flawless+skin.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 142,
                "name": "10 Fast and easy make up tips",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/10+Fast+and+easy+make+up+tips.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/10+Fast+and+easy+make+up+tips.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 143,
                "name": "10 Make up tips and tricks for Oily Skin",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/10+Make+up+tips+and+tricks+for+Oily+Skin.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/10+Make+up+tips+and+tricks+for+Oily+Skin.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 144,
                "name": "13 Make up mistakes to avoid",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/13+Make+up+mistakes+to+avoid.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/13+Make+up+mistakes+to+avoid.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 145,
                "name": "101 Tips for beginner make up",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/101+Tips+for+beginner+make+up.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/101+Tips+for+beginner+make+up.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 146,
                "name": "Asian beauty tips you must do now",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Asian+beauty+tips+you+must+do+now.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Asian+beauty+tips+you+must+do+now.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id":147,
                "name": "Beginner every make up tips and tricks for you",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Beginner+every+make+up+tips+and+tricks+for+you.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Beginner+every+make+up+tips+and+tricks+for+you.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 148,
                "name": "Best make up artist tips you need to know",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Best+make+up+artist+tips+you+need+to+know.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Best+make+up+artist+tips+you+need+to+know.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 149,
                "name": "Essential make up tips for summer glow",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Essential+make+up+tips+for+summer+glow.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Essential+make+up+tips+for+summer+glow.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 150,
                "name": "Flattering eyes make up for you",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Flattering+eyes+make+up+for+you.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Flattering+eyes+make+up+for+you.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 151,
                "name": "Foundation tricks for oily Skin",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Foundation+tricks+for+oily+Skin.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Foundation+tricks+for+oily+Skin.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 152,
                "name": "Full coverage foundation routine for you",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Full+coverage+foundation+routine+for+you.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Full+coverage+foundation+routine+for+you.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 153,
                "name": "Look Fierce with drugstore make up",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Look+Fierce+with+drugstore+make+up.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Look+Fierce+with+drugstore+make+up.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 154,
                "name": "Make up essentials for dark skin tones",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make+up+essentials+for+dark+skin+tones.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make+up+essentials+for+dark+skin+tones.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 155,
                "name": "Make up tips for aging eyes",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make+up+tips+for+aging+eyes.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make+up+tips+for+aging+eyes.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 156,
                "name": "Make up tips for flawless skin",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make+up+tips+for+flawless+skin.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Make+up+tips+for+flawless+skin.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 157,
                "name": "Must know make up tips",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Must+know+make+up+tips.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Must+know+make+up+tips.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 158,
                "name": "Must know wake up tips",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Must+know+wake+up+tips.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Must+know+wake+up+tips.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 159,
                "name": "Natural make up korean style",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Natural+make+up+korean+style.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Natural+make+up+korean+style.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 160,
                "name": "Natural make up tips for men",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Natural+make+up+tips+for+men.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Natural+make+up+tips+for+men.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 161,
                "name": "Natural to Glamorous",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Natural+to+Glamorous.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Natural+to+Glamorous.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 162,
                "name": "Over 40 aged woman make up tips",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Over+40+aged+woman+make+up+tips.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Over+40+aged+woman+make+up+tips.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 163,
                "name": "Pro make up tips by Tati",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Pro+make+up+tips+by+Tati.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Pro+make+up+tips+by+Tati.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 164,
                "name": "Secret Make up tips and tricks for beginners",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Secret+Make+up+tips+and+tricks+for+beginners.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Secret+Make+up+tips+and+tricks+for+beginners.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 165,
                "name": "Simple Tips for Eyeshadow",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Simple+Tips+for+Eyeshadow.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Simple+Tips+for+Eyeshadow.mp4",
                "filename":"",
            },

            {
                "duration": "Watch Now",
                "id": 166,
                "name": "Summer make up meltproof tips",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Summer+make+up+meltproof+tips.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Summer+make+up+meltproof+tips.mp4",
                "filename":"",
            },{
                "duration": "Watch Now",
                "id": 167,
                "name": "Top 10 secret tips of celebrities",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Top+10+secret+tips+of+celebrities.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Top+10+secret+tips+of+celebrities.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 168,
                "name": "Top 25 make up tips for pale skin",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Top+25+make+up+tips+for+pale+skin.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Top+25+make+up+tips+for+pale+skin.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 169,
                "name": "Tyra Banks make up tips",
                "preview": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Tyra+Banks+make+up+tips.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Fashion+%26+Beauty/Tyra+Banks+make+up+tips.mp4",
                "filename":"",
            },

        ]
    },
    {
    "id" : 10,
        "contents" : 10,
        "name" : {
            "en": "E-Learning",
            "be": "E-learning",
            "id": "E-Learning",
            "it": "E-Learning",
            "se": "E-inlärning",
            "no": "E-Learning",
            "fr": "E-learning",
            "ee": "E-õpe",
            "lv":"E-mācīšanās",
            "lt":"E-mokymasis",
            "sr":"Е-учење",
            "el":"Ηλεκτρονική Μάθηση",
            "de":"E-Learning",
            "cs":"E-Learning",
            "es": "E-Learning",
            "pt": "Aprendizagem Digital"
        },
        "videos" : [
            {
                "duration" : "Watch Now",
                "id" : 40,
                "name": "Arabic Eps 1 - How to introduce yourself",
                "preview" : "https://cdn.mobiotv.com/bidiotv/E-Learning/Learn+Arabic+Eps+1+-+How+to+introduce+yourself.jpg",
                "desc" : "",
                "videoUrl":"https://cdn.bidiotv.com/E-Learning/Learn+Arabic+Ep1+-+How+to+introduce+yourself.mp4",
                "filename":"bidiotv/E-Learning/Learn+Arabic+Ep1+-+How+to+introduce+yourself.mp4",
            },
            {
                "duration" : "Watch Now",
                "id" : 41,
                "name": "Arabic Eps 2 - Thank you",
                "preview" : "https://cdn.mobiotv.com/bidiotv/E-Learning/Learn+Arabic+Eps+2+-+Thank+you.jpg",
                "desc" : "",
                "videoUrl":"https://cdn.bidiotv.com/E-Learning/Learn+Arabic+Ep2+-+Thank+you.mp4",
                "filename":"bidiotv/E-Learning/Learn+Arabic+Ep2+-+Thank+you.mp4",
            },
            {
                "duration" : "Watch Now",
                "id" : 42,
                "name": "English Eps 3 - Asking About Hobbies",
                "preview" : "https://cdn.mobiotv.com/bidiotv/E-Learning/English+Eps+3+-+Asking+About+Hobbies.jpg",
                "desc" : "",
                "videoUrl":"https://cdn.bidiotv.com/E-Learning/Learn+English+Ep3+-+Asking+About+Hobbies.mp4",
                "filename":"bidiotv/E-Learning/Learn+English+Ep3+-+Asking+About+Hobbies.mp4",
            },
            {
                "duration" : "Watch Now",
                "id" : 43,
                "name": "English Eps 4 - Where are you from",
                "preview" : "https://cdn.mobiotv.com/bidiotv/E-Learning/English+Eps+4+-+Where+are+you+from.jpg",
                "desc" : "",
                "videoUrl":"https://cdn.bidiotv.com/E-Learning/Learn+English+Ep4+-+Where+are+you+from.mp4",
                "filename":"bidiotv/E-Learning/Learn+English+Ep4+-+Where+are+you+from.mp4",
            },
            {
                "duration" : "Watch Now",
                "id" : 44,
                "name": "French Eps 5 - How to Apologize",
                "preview" : "https://cdn.mobiotv.com/bidiotv/E-Learning/French+Eps+5+-+How+to+Apologize.jpg",
                "desc" : "",
                "videoUrl":"https://cdn.bidiotv.com/E-Learning/Learn+French+Ep5+-+How+to+Apologize.mp4",
                "filename":"bidiotv/E-Learning/Learn+French+Ep5+-+How+to+Apologize.mp4",
            },
            {
                "duration" : "Watch Now",
                "id" : 45,
                "name": "French Eps 6 - Asking do you Speak English",
                "preview" : "https://cdn.mobiotv.com/bidiotv/E-Learning/French+Eps+6+-+Asking+do+you+Speak+English.jpg",
                "desc" : "",
                "videoUrl":"https://cdn.bidiotv.com/E-Learning/Learn+French+Ep6+-+Asking+do+you+Speak+English.mp4",
                "filename":"bidiotv/E-Learning/Learn+French+Ep6+-+Asking+do+you+Speak+English.mp4",
            },
            {
                "duration" : "Watch Now",
                "id" : 46,
                "name": "Italian Eps 7- Apologies",
                "preview" : "https://cdn.mobiotv.com/bidiotv/E-Learning/Italian+Eps+7-+Apologies.jpg",
                "desc" : "",
                "videoUrl":"https://cdn.bidiotv.com/E-Learning/Learn+Italian+Ep7-+Apologies.mp4",
                "filename":"bidiotv/E-Learning/Learn+Italian+Ep7-+Apologies.mp4",
            },
            {
                "duration" : "Watch Now",
                "id" : 47,
                "name": "Italian Eps 8 - How much",
                "preview" : "https://cdn.mobiotv.com/bidiotv/E-Learning/Italian+Eps+8+-+How+much.jpg",
                "desc" : "",
                "videoUrl":"https://cdn.bidiotv.com/E-Learning/Learn+Italian+Ep8-how+much.mp4",
                "filename":"bidiotv/E-Learning/Learn+Italian+Ep8-how+much.mp4",
            },
            {
                "duration" : "Watch Now",
                "id" : 48,
                "name": "Spanish Eps 9 - Where are you from",
                "preview" : "https://cdn.mobiotv.com/bidiotv/E-Learning/Spanish+Eps+9+-+Where+are+you+from.jpg",
                "desc" : "",
                "videoUrl":"https://cdn.bidiotv.com/E-Learning/Learn+Spanish+Ep9+-+Where+are+you+from.mp4",
                "filename":"bidiotv/E-Learning/Learn+Spanish+Ep9+-+Where+are+you+from.mp4",
            },
            {
                "duration" : "Watch Now",
                "id" : 49,
                "name": "Spanish Eps 10 - What's up",
                "preview" : "https://cdn.mobiotv.com/bidiotv/E-Learning/Spanish+Eps+10+-+What's+up.jpg",
                "desc" : "",
                "videoUrl":"https://cdn.bidiotv.com/E-Learning/Learn+Spanish+Ep10+-+What's+up.mp4",
                "filename":"bidiotv/E-Learning/Learn+Spanish+Ep10+-+What's+up.mp4",
            },
        ]
    },
    {
        "id": 11,
        "contents": 11,
        "name": {
            "en": "Yoga",
            "be": "Yoga",
            "id": "Yoga",
            "it": "Yoga",
            "se": "Yoga",
            "no": "Yoga",
            "fr": "Yoga",
            "ee": "Jooga",
            "lv":"Joga",
            "lt":"Joga",
            "sr":"Јога",
            "el":"Γιόγκα",
            "de":"Yoga",
            "cs":"Jóga",
            "es": "Yoga",
            "pt": "Ioga"
        },
        "videos": [
            {
                "duration": "Watch Now",
                "id": 50,
                "name": "How to Post Natal Yoga Breathing Exercise",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/How+to+Post+Natal+Yoga++Breathing+Exercise.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Yoga/How+to+Post+Natal+Yoga++Breathing+Exercise.mp4",
                "filename":"bidiotv/Yoga/How+to+Post+Natal+Yoga++Breathing+Exercise.mp4",
            },
            {   
                "duration": "Watch Now",
                "id": 51,
                "name": "How to Post Natal Yoga Breathing Exercise",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/How+to+Post+Natal+Yoga++Chair+Exercises.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Yoga/How+to+Post+Natal+Yoga++Chair+Exercises.mp4",
                "filename":"bidiotv/Yoga/How+to+Post+Natal+Yoga++Chair+Exercises.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 52,
                "name": "How to Post Natal Yoga Twist Walk",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/How+to+Post+Natal+Yoga++Twist+Walk.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Yoga/How+to+Post+Natal+Yoga++Twist+Walk.mp4",
                "filename":"bidiotv/Yoga/How to Post Natal Yoga  Twist Walk.mp4",           
            },
            {
                "duration": "Watch Now",
                "id": 53,
                "name": "How to in 60 seconds",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/How+to+in+60+seconds.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Yoga/How+to+in+60+seconds.mp4",
                "filename":"bidiotv/Yoga/How+to+Post+Natal+Yoga++Twist+Walk.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 54,
                "name": "How to post natal yoga - Dandasana",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/How+to+post+natal+yoga+-+Dandasana.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Yoga/How+to+post+natal+yoga+-+Dandasana.mp4",
                "filename":"bidiotv/Yoga/How+to+post+natal+yoga+-+Dandasana.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 55,
                "name": "How to post natal yoga - If baby needs entertainment",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/How+to+post+natal+yoga+-+If+baby+needs+entertainment.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Yoga/How+to+post+natal+yoga+-+If+baby+needs+entertainment.mp4",
                "filename":"bidiotv/Yoga/How+to+post+natal+yoga+-+If+baby+needs+entertainment.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 56,
                "name": "Pilates  Breast stroke",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Pilates++Breast+stroke.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Yoga/Pilates++Breast+stroke.mp4",
                "filename":"bidiotv/Yoga/Pilates++Breast+stroke.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 57,
                "name": "Pilates  Half roll back",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Pilates++Half+roll+back.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Yoga/Pilates++Half+roll+back.mp4",
                "filename":"bidiotv/Yoga/Pilates++Half+roll+back.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 58,
                "name": "Pilates  Hip roll",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Pilates++Hip+roll.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Yoga/Pilates++Hip+roll.mp4",
                "filename":"bidiotv/Yoga/Pilates++Hip+roll.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 59,
                "name": "Pilates  Intro push-up",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Pilates++Intro+push-up.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Yoga/Pilates++Intro+push-up.mp4",
                "filename":"bidiotv/Yoga/Pilates++Intro+push-up.mp4",
            },
            // {
            //     "duration": "Watch Now",
            //     "id": 107,
            //     "name": "1 Minute yoga Guide",
            //     "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/1+Minute+yoga+Guide.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/1+Minute+yoga+Guide.mp4",
            //     "filename":"",
            // },
            {
                "duration": "Watch Now",
                "id": 108,
                "name": "1 Minute yoga guides",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/1+Minute+yoga+guides.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/1+Minute+yoga+guides.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 109,
                "name": "Become flexible with yoga",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Become+flexible+with+yoga.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Become+flexible+with+yoga.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 110,
                "name": "Blend with Yoga",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Blend+with+Yoga.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Blend+with+Yoga.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 111,
                "name": "Fast and effective fatloss yoga",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Fast+and+effective+fatloss+yoga.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Fast+and+effective+fatloss+yoga.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 112,
                "name": "Find peace at home with yoga",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Find+peace+at+home+with+yoga.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Find+peace+at+home+with+yoga.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 113,
                "name": "Find peace with yoga",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Find+peace+with+yoga.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Find+peace+with+yoga.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 114,
                "name": "Free your body & mind",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Free+your+body+%26+mind.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Free+your+body+%26+mind.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 115,
                "name": "Get abs with yoga",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Get+abs+with+yoga.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Get+abs+with+yoga.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 116,
                "name": "Get slim & fit with yoga",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Get+slim+%26+fit+with+yoga.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Get+slim+%26+fit+with+yoga.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 117,
                "name": "Learn the art of yoga",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Learn+the+art+of+yoga.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Learn+the+art+of+yoga.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 118,
                "name": "Lost weight with yoga",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Lost+weight+with+yoga.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Lost+weight+with+yoga.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 119,
                "name": "Master core yoga poses",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Master+core+yoga+poses.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Master+core+yoga+poses.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 120,
                "name": "Mind over matter",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Mind+over+matter.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Mind+over+matter.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 121,
                "name": "Stretch beyond with yoga",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Stretch+beyond+with+yoga.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Stretch+beyond+with+yoga.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 122,
                "name": "Ultimate yoga guide",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Ultimate+yoga+guide.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Ultimate+yoga+guide.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 123,
                "name": "Yoga village",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Yoga+village.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Yoga+village.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 124,
                "name": "Yoga your way to healthy living",
                "preview": "https://cdn.mobiotv.com/bidiotv/Yoga/Yoga+your+way+to+healthy+living.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Yoga/Yoga+your+way+to+healthy+living.mp4",
                "filename":"",
            }
            

        ]
    },
    {
        "id": 12,
        "contents": 24,
        "name": {
            "en": "Just For Laugh",
            "be": "Gewoon om te lachen",
            "id": "Just for Laugh",
            "it": "Facciamoci una risata",
            "se": "Bara på skoj",
            "no": "Just For Laugh",
            "fr": "Juste pour rire",
            "ee": "Huumor",
            "lv":"Tikai smiekli",
            "lt":"Juokams",
            "sr":"Само за смех",
            "el":"Για γέλια",
            "de":"Zum Lachen",
            "cs":"Jen pro smích",
            "es": "Sólo para reírse",
            "pt": "Só para Rir"
        },
        "videos": [
            {
                "duration": "Watch Now",
                "id": 70,
                "name": "Animals Exoticos",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Animals+Exoticos.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Animals+Exoticos.mp4",
                "filename":"bidiotv/Just+For+Laugh/Animals+Exoticos.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 71,
                "name": "Automatu",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Automatu.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Automatu.mp4",
                "filename":"bidiotv/Just+For+Laugh/Automatu.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 72,
                "name": "Babies and Moving Table Part 1",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Babies_and_Moving_Table_Part+1.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Babies_and_Moving_Table_Part+1.mp4",
                "filename":"bidiotv/Just+For+Laugh/Babies_and_Moving_Table_Part+1.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 73,
                "name": "Bad Kids Throw Orange Peels Part 1",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Bad_KidsThrow_Orange_Peels_Part+1.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Bad_KidsThrow_Orange_Peels_Part+1.mp4",
                "filename":"bidiotv/Just+For+Laugh/Bad_KidsThrow_Orange_Peels_Part+1.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 74,
                "name": "Big Bunny Scares Babies Part 1",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Big+Bunny+Scares+Babies+Part1.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Big+Bunny+Scares+Babies+Part1.mp4",
                "filename":"bidiotv/Just+For+Laugh/Big+Bunny+Scares+Babies+Part1.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 75,
                "name": "Blind Man Groping Part 1",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Blind+Man+Groping+Part1.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Blind+Man+Groping+Part1.mp4",
                "filename":"bidiotv/Just+For+Laugh/Blind+Man+Groping+Part1.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 76,
                "name": "Bodyguards",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Bodyguards.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Bodyguards.mp4",
                "filename":"bidiotv/Just+For+Laugh/Bodyguards.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 77,
                "name": "Cake on Face",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Cake+on+Face.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Cake+on+Face.mp4",
                "filename":"bidiotv/Just+For+Laugh/Cake+on+Face.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 78,
                "name": "Can I Click your photo",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Can+I+Click+your+photo.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Can+I+Click+your+photo.mp4",
                "filename":"bidiotv/Just+For+Laugh/Can+I+Click+your+photo.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 79,
                "name": "Car Parking",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Car+Parking.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Car+Parking.mp4",
                "filename":"bidiotv/Just+For+Laugh/Car+Parking.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 80,
                "name": "Car for Sale",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Car+for+Sale.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Car+for+Sale.mp4",
                "filename":"bidiotv/Just+For+Laugh/Car+for+Sale.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 81,
                "name": "Man Falling on Ladder",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Man+Falling+on+Ladder.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Man+Falling+on+Ladder.mp4",
                "filename":"bidiotv/Just+For+Laugh/Man+Falling+on+Ladder.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 82,
                "name": "Man in Garbage Can Part 1",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Man+in+Garbage+Can+Part1.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Man+in+Garbage+Can+Part1.mp4",
                "filename":"bidiotv/Just+For+Laugh/Man+in+Garbage+Can+Part1.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 83,
                "name": "Painting Exhibition",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/PAinting+Exhibition.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/PAinting+Exhibition.mp4",
                "filename":"bidiotv/Just+For+Laugh/PAinting+Exhibition.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 84,
                "name": "Pervert with Handy Cam Part 1",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Pervert+with+Handy+Cam+Part1.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Pervert+with+Handy+Cam+Part1.mp4",
                "filename":"bidiotv/Just+For+Laugh/Pervert+with+Handy+Cam+Part1.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 85,
                "name": "Reckless Blind Man Part 1",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Reckless+Blind+Man+Part1.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Reckless+Blind+Man+Part1.mp4",
                "filename":"bidiotv/Just+For+Laugh/Reckless+Blind+Man+Part1.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 86,
                "name": "Roller Blader Part 1",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Roller+Blader+Part1.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Roller+Blader+Part1.mp4",
                "filename":"bidiotv/Just+For+Laugh/Roller+Blader+Part1.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 87,
                "name": "Rude Man on Beach Part 1",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/Rude_Man_on_Beach_Part+1.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/Rude_Man_on_Beach_Part+1.mp4",
                "filename":"bidiotv/Just+For+Laugh/Rude_Man_on_Beach_Part+1.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 88,
                "name": "Santa Claus The Pervert Part 1",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/SantaCluas_The_Pervert_Part+1.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/SantaCluas_The_Pervert_Part+1.mp4",
                "filename":"bidiotv/Just+For+Laugh/SantaCluas_The_Pervert_Part+1.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 89,
                "name": "Baby Carier on Car",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/baby+carier+on+car.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/baby+carier+on+car.mp4",
                "filename":"bidiotv/Just+For+Laugh/baby+carier+on+car.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 90,
                "name": "Bleeding Nose",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/bleeding+nose.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/bleeding+nose.mp4",
                "filename":"bidiotv/Just+For+Laugh/bleeding+nose.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 91,
                "name": "Money Falling",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/money+falling.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/money+falling.mp4",
                "filename":"bidiotv/Just+For+Laugh/money+falling.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 92,
                "name": "Open This Pen",
                "preview": "https://cdn.mobiotv.com/bidiotv/Just+For+Laugh/open+this+pen.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Just+For+Laugh/open+this+pen.mp4",
                "filename":"bidiotv/Just+For+Laugh/open+this+pen.mp4",
            },
        ]
    },
    {
        "id": 13,
        "contents": 24,
        "name": {
            "en": "Brain Boost",
            "be": "Hersenversterking",
            "id": "Brain Boost",
            "it": "Stimola la mente",
            "se": "Hjärnträning",
            "no": "Brain Boost",
            "fr": "Boostez votre cerveau",
            "ee": "Mälutreening",
            "lv":"Erudīcijai",
            "lt":"Smegenims lavinti",
            "sr":"Браин Боост",
            "el":"Ενίσχυση εγκεφάλου",
            "de":"Brain Boost",
            "cs":"Posilování mozku",
            "es": "Estimulación cerebral",
            "pt": "Impulso Cerebral"
        },
        "videos": [
            {
                "duration": "Watch Now",
                "id": 93,
                "name": "Ditch the doctor! How about diagnosis by computer",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Ditch+the+doctor!+How+about+diagnosis+by+computer.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Brain+Boost/Ditch+the+doctor!+How+about+diagnosis+by+computer.mp4",
                "filename":"bidiotv/Brain+Boost/Ditch+the+doctor!+How+about+diagnosis+by+computer.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 94,
                "name": "ESPN's new deal dives into the world of drone racing",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Brain+Boost/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.mp4",
                "filename":"bidiotv/Brain+Boost/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 95,
                "name": "Ever wished beer could fly Now it can!",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Ever+wished+beer+could+fly+Now+it+can!.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Brain+Boost/Ever+wished+beer+could+fly+Now+it+can!.mp4",
                "filename":"bidiotv/Brain+Boost/Ever+wished+beer+could+fly+Now+it+can!.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 96,
                "name": "Hearing things Here are 5 facts on our inner voice",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Hearing+things+Here+are+5+facts+on+our+inner+voice.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Brain+Boost/Hearing+things+Here+are+5+facts+on+our+inner+voice.mp4",
                "filename":"bidiotv/Brain+Boost/Hearing+things+Here+are+5+facts+on+our+inner+voice.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 97,
                "name": "Is spotty skin the answer to looking younger",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Is+spotty+skin+the+answer+to+looking+younger.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Brain+Boost/Is+spotty+skin+the+answer+to+looking+younger.mp4",
                "filename":"bidiotv/Brain+Boost/Is+spotty+skin+the+answer+to+looking+younger.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 98,
                "name": "Just why are the Dutch so tall",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Just+why+are+the+Dutch+so+tall.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Brain+Boost/Just+why+are+the+Dutch+so+tall.mp4",
                "filename":"bidiotv/Brain+Boost/Just+why+are+the+Dutch+so+tall.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 99,
                "name": "Meet the robot that wants to get to know you",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Meet+the+robot+that+wants+to+get+to+know+you.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Brain+Boost/Meet+the+robot+that+wants+to+get+to+know+you.mp4",
                "filename":"bidiotv/Brain+Boost/Meet+the+robot+that+wants+to+get+to+know+you.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 100,
                "name": "Star Wars becomes reality in a post-apocalyptic mall",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Star+Wars+becomes+reality+in+a+post+apocalyptic+mall.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Brain+Boost/Star+Wars+becomes+reality+in+a+post-apocalyptic+mall.mp4",
                "filename":"bidiotv/Brain+Boost/Star+Wars+becomes+reality+in+a+post-apocalyptic+mall.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 101,
                "name": "Sugar tax The answer to obesity pandemic",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Sugar+tax++The+answer+to+obesity+pandemic.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Brain+Boost/Sugar+tax++The+answer+to+obesity+pandemic.mp4",
                "filename":"bidiotv/Brain+Boost/Sugar+tax++The+answer+to+obesity+pandemic.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 102,
                "name": "Swallow this nano chip to know what s making you sick",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Swallow+this+nano+chip+to+know+what+s+making+you+sick.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Brain+Boost/Swallow+this+nano+chip+to+know+what+s+making+you+sick.mp4",
                "filename":"bidiotv/Brain+Boost/Swallow+this+nano+chip+to+know+what+s+making+you+sick.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 103,
                "name": "The exploding cost of cyberattacks",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/The+exploding+cost+of+cyberattacks.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Brain+Boost/The+exploding+cost+of+cyberattacks.mp4",
                "filename":"bidiotv/Brain+Boost/The+exploding+cost+of+cyberattacks.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 104,
                "name": "Turns out emails didn't solve our waste paper problems",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Turns+out+emails+didn+t+solve+our+waste+paper+problems.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Turns+out+emails+didn+t+solve+our+waste+paper+problems.mp4",
                "filename":"bidiotv/Brain+Boost/Turns+out+emails+didn+t+solve+our+waste+paper+problems.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 105,
                "name": "UK Drone Show The latest consumer industry trends",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/UK+Drone+Show++The+latest+consumer+industry+trends.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Brain+Boost/UK+Drone+Show++The+latest+consumer+industry+trends.mp4",
                "filename":"bidiotv/Brain+Boost/UK+Drone+Show++The+latest+consumer+industry+trends.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 106,
                "name": "VR Running of the Bulls! A fearful thrillseekers dream",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/VR+Running+of+the+Bulls!+A+fearful+thrillseekers+dream.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Brain+Boost/VR+Running+of+the+Bulls!+A+fearful+thrillseekers+dream.mp4",
                "filename":"bidiotv/Brain+Boost/VR+Running+of+the+Bulls!+A+fearful+thrillseekers+dream.mp4",
            },
        ]
    },
    {
        "id":14,
        "contents":25,
        "name": {
            "en": "Rugby",
            "be": "Rugby",
            "id": "Rugby",
            "it": "Rugby",
            "se": "Rugby",
            "no": "Rugby",
            "fr": "Rugby",
            "ee": "Ragbi",
            "lv":"Regbijs",
            "lt":"Regbis",
            "sr":"Рагби",
            "el":"Ράγκμπι",
            "de":"Rugby",
            "cs":"Ragby",
            "es": "Rugby",
            "pt": "Rugby"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 125,
                "name": "Best Rugby Skills - Steps, Tricks, Offloads Compilation",
                "preview": "https://cdn.mobiotv.com/bidiotv/Rugby/Best+Rugby+Skills+-+Steps%2C+Tricks%2C+Offloads+Compilation.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Rugby/Best+Rugby+Skills+-+Steps%2C+Tricks%2C+Offloads+Compilation.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 126,
                "name": "Best Rugby Skills 2018",
                "preview": "https://cdn.mobiotv.com/bidiotv/Rugby/Best+Rugby+Skills+2018.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Rugby/Best+Rugby+Skills+2018.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 127,
                "name": "Best Rugby Tries 2018",
                "preview": "https://cdn.mobiotv.com/bidiotv/Rugby/Best+Rugby+Tries+2018.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Rugby/Best+Rugby+Tries+2018.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 128,
                "name": "Craziest Rugby Skills",
                "preview": "https://cdn.mobiotv.com/bidiotv/Rugby/Craziest+Rugby+Skills.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Rugby/Craziest+Rugby+Skills.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 129,
                "name": "Epic Rugby Skills 2017",
                "preview": "https://cdn.mobiotv.com/bidiotv/Rugby/Epic+Rugby+Skills+2017.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Rugby/Epic+Rugby+Skills+2017.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 130,
                "name": "Epic Rugby Steps 2018",
                "preview": "https://cdn.mobiotv.com/bidiotv/Rugby/Epic+Rugby+Steps+2018.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Rugby/Epic+Rugby+Steps+2018.mp4",
                "filename":"",
            },{
                "duration": "Watch Now",
                "id": 131,
                "name": "Rugby Big Hits 2018",
                "preview": "https://cdn.mobiotv.com/bidiotv/Rugby/Rugby+Big+Hits+2018.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Rugby/Rugby+Big+Hits+2018.mp4",
                "filename":""
            }
        ]

    },
    {
        "id":15,
        "contents":25,
        "name": {
            "en": "Astrology",
            "be": "Astrologie",
            "id": "Astrologi",
            "it": "Astrologia",
            "se": "Astrologi",
            "no": "Astrologi",
            "fr": "Astrologie",
            "ee": "Astroloogia",
            "lv":"Astroloģija",
            "lt":"Astrologija",
            "sr":"Астрологи",
            "el":"Αστρολογία",
            "de":"Astrologie",
            "cs":"Astrologie",
            "es": "Astrología",
            "pt": "Astrologia"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 132,
                "name": "Powerful zodiak 2019",
                "preview": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Powerful+zodiac+2019.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Brain+Boost/Powerful+zodiac+2019.mp4",
                "filename":""
            },
            {
                "duration": "Watch Now",
                "id": 133,
                "name": "Channeled message from your spirit guides",
                "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/Channeled+message+from+your+spirit+guides.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/Channeled+message+from+your+spirit+guides.mp4",
                "filename":""
            },
            {
                "duration": "Watch Now",
                "id": 134,
                "name": "HOW & WHEN You Will You Become SUCCESSFUL",
                "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/HOW+%26+WHEN+You+Will+You+Become+SUCCESSFUL.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/HOW+%26+WHEN+You+Will+You+Become+SUCCESSFUL.mp4",
                "filename":""
            },
            {
                "duration": "Watch Now",
                "id": 135,
                "name": "How do people you date-dated see you",
                "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/How+do+people+you+date-dated+see+you.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/How+do+people+you+date-dated+see+you.mp4",
                "filename":""
            },
            {
                "duration": "Watch Now",
                "id": 136,
                "name": "Pick a card - Are they secretly thinking about you",
                "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/Pick+A+Card+-+What+Do+They+Secretly+Want+to+Tell+You.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/Pick+A+Card+-+What+Do+They+Secretly+Want+to+Tell+You.mp4",
                "filename":""
            },
            {
                "duration": "Watch Now",
                "id": 137,
                "name": "Pick A Card - What Do They Secretly Want to Tell You",
                "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/Pick+a+card+-+Are+they+secretly+thinking+about+you.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/Pick+a+card+-+Are+they+secretly+thinking+about+you.mp4",
                "filename":""
            },
            {
                "duration": "Watch Now",
                "id": 138,
                "name": "What’s Coming for You in 2019",
                "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/What%E2%80%99s+Coming+for+You+in+2019.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/What%E2%80%99s+Coming+for+You+in+2019.mp4",
                "filename":""
            },
            {
                "duration": "Watch Now",
                "id": 139,
                "name": "Why do they act like this What's going on with them",
                "preview": "https://cdn.mobiotv.com/bidiotv/Astrology/Why+do+they+act+like+this+What's+going+on+with+them.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Astrology/Why+do+they+act+like+this+What's+going+on+with+them.mp4",
                "filename":""
            }
        ]

    },
    {
        "id":16,
        "contents":25,
        "name": {
            "en": "Economy",
            "be": "Economie",
            "id": "Economy",
            "it": "Economia",
            "se": "Ekonomi",
            "no": "Economy",
            "fr": "Économie",
            "ee": "Majandus",
            "lv":"Ekonomika",
            "lt":"Ekonomika",
            "sr":"Економија",
            "el":"Οικονομία",
            "de":"Wirtschaft",
            "cs":"Ekonomika",
            "es": "Economía",
            "pt": "Economia"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 728,
                "name": "4 lessons to learn from business mogul Arianna Huffington",
                "preview": "https://cdn.mobiotv.com/bidiotv/Economy/4+lessons+to+learn+from+business+mogul+Arianna+Huffington.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Economy/4+lessons+to+learn+from+business+mogul+Arianna+Huffington.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 729,
                "name": "Builders of Tomorrow A Future Paved with Plastic",
                "preview": "https://cdn.mobiotv.com/bidiotv/Economy/Builders+of+Tomorrow+A+Future+Paved+with+Plastic.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Economy/Builders+of+Tomorrow+A+Future+Paved+with+Plastic.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 730,
                "name": "Just how vulnerable are jobs to robot takeovers",
                "preview": "https://cdn.mobiotv.com/bidiotv/Economy/Just+how+vulnerable+are+jobs+to+robot+takeovers.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Economy/Just+how+vulnerable+are+jobs+to+robot+takeovers.mp4",
                "filename":"",
            },
        ]
    },
    {
        "id":17,
        "contents":25,
        "name": {
            "en": "Entertainment News",
            "be": "Nieuws",
            "id": "Entertainment News",
            "it": "Notizie di intrattenimento",
            "se": "Underhållnings Nyheter",
            "no": "Entertainment News",
            "fr": "Nouvelles de divertissement",
            "ee": "Meelelahutuse uudised",
            "lv":"Izklaides ziņas",
            "lt":"Pramogų pasaulio naujienos",
            "sr":"Ентертаинмент Невс",
            "el":"Ειδήσεις ψυχαγωγίας",
            "de":"Unterhaltung",
            "cs":"Novinky ze zábavy",
            "es": "Noticias de entretenimiento",
            "pt": "Notícias de Entretenimento"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 731,
                "name": "3 Facts to know about Cindy Crawford's hot model son",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/3+Facts+to+know+about+Cindy+Crawford's+hot+model+son.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/3+Facts+to+know+about+Cindy+Crawford's+hot+model+son.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 732,
                "name": "5 Things to know before watching the Lion King live action",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/5+Things+to+know+before+watching+the+Lion+King+live+action.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/5+Things+to+know+before+watching+the+Lion+King+live+action.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 733,
                "name": "All the political statements in Miley Cyrus's new music video",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/All+the+political+statements+in+Miley+Cyrus's+new+music+video.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/All+the+political+statements+in+Miley+Cyrus's+new+music+video.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 734,
                "name": "Here's Romee Strijd just lounging at home in a swimsuit",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Here's+Romee+Strijd+just+lounging+at+home+in+a+swimsuit.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Here's+Romee+Strijd+just+lounging+at+home+in+a+swimsuit.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 735,
                "name": "Is Khloé Kardashian spoiling daughter True too much",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Is+Khloe%CC%81+Kardashian+spoiling+daughter+True+too+much.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Is+Khloe%CC%81+Kardashian+spoiling+daughter+True+too+much.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 736,
                "name": "Kylie Jenner recreates iconic Naomi Campbell bikini moment",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Kylie+Jenner+recreates+iconic+Naomi+Campbell+bikini+moment.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Kylie+Jenner+recreates+iconic+Naomi+Campbell+bikini+moment.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 737,
                "name": "Lady Gaga's beauty brand set for global domination",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Lady+Gaga's+beauty+brand+set+for+global+domination.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Lady+Gaga's+beauty+brand+set+for+global+domination.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 738,
                "name": "Serena Williams hints at fashion career after tennis",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Serena+Williams+hints+at+fashion+career+after+tennis.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Serena+Williams+hints+at+fashion+career+after+tennis.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 739,
                "name": "Taylor Swift's 'Cats' role is sassy, flirty & sparkly",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Taylor+Swift's+'Cats'+role+is+sassy%2C+flirty+%26+sparkly.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Taylor+Swift's+'Cats'+role+is+sassy%2C+flirty+%26+sparkly.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 740,
                "name": "The 5 most expensive Netflix shows ever",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/The+5+most+expensive+Netflix+shows+ever.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/The+5+most+expensive+Netflix+shows+ever.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 741,
                "name": "The new 007 is 'black, beautiful and a woman’",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/The+new+007+is+'black%2C+beautiful+and+a+woman%E2%80%99.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/The+new+007+is+'black%2C+beautiful+and+a+woman%E2%80%99.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 742,
                "name": "What's next for Kevin Spacey",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/What's+next+for+Kevin+Spacey.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/What's+next+for+Kevin+Spacey.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 743,
                "name": "Will Smith jokes Jaden is being cut off financially on 21st birthday",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Will+Smith+jokes+Jaden+is+being+cut+off+financially+on+21st+birthday.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/Will+Smith+jokes+Jaden+is+being+cut+off+financially+on+21st+birthday.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 744,
                "name": "You won't believe how different Priyanka Chopra looked",
                "preview": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/You+won't+believe+how+different+Priyanka+Chopra+looked.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Entertainment+News/You+won't+believe+how+different+Priyanka+Chopra+looked.mp4",
                "filename":"",
            },
            
        ]
    },
    {
        "id":18,
        "contents":25,
        "name": {
            "en": "Environment",
            "be": "Milieu",
            "id": "Environment",
            "it": "Ambiente",
            "se": "Miljö",
            "no": "Environment",
            "fr": "Environnement",
            "ee": "Keskkond",
            "lv":"Vide",
            "lt":"Aplinka",
            "sr":"Животна средина",
            "el":"Περιβάλλον",
            "de":"Umwelt",
            "cs":"Životní prostředí",
            "es": "Medio ambiente",
            "pt": "Meio Ambiente"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 745,
                "name": "Builders of Tomorrow Solar water heater from plastic bottles",
                "preview": "https://cdn.mobiotv.com/bidiotv/Environment/Builders+of+Tomorrow+Solar+water+heater+from+plastic+bottles.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Environment/Builders+of+Tomorrow+Solar+water+heater+from+plastic+bottles.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 746,
                "name": "Got plastic Here are four innovative ways to deal with it!",
                "preview": "https://cdn.mobiotv.com/bidiotv/Environment/Got+plastic+Here+are+four+innovative+ways+to+deal+with+it!.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Environment/Got+plastic+Here+are+four+innovative+ways+to+deal+with+it!.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 747,
                "name": "If you watch porn, this is how you can help the planet",
                "preview": "https://cdn.mobiotv.com/bidiotv/Environment/If+you+watch+porn%2C+this+is+how+you+can+help+the+planet.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Environment/If+you+watch+porn%2C+this+is+how+you+can+help+the+planet.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 748,
                "name": "Saving the Planet and Making Art, One Butt at a Time",
                "preview": "https://cdn.mobiotv.com/bidiotv/Environment/Saving+the+Planet+and+Making+Art%2C+One+Butt+at+a+Time.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Environment/Saving+the+Planet+and+Making+Art%2C+One+Butt+at+a+Time.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 749,
                "name": "The fastest way to save the planet",
                "preview": "https://cdn.mobiotv.com/bidiotv/Environment/The+fastest+way+to+save+the+planet.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Environment/The+fastest+way+to+save+the+planet.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 750,
                "name": "The Unique Artist Turning Tires In Masterpieces",
                "preview": "https://cdn.mobiotv.com/bidiotv/Environment/The+Unique+Artist+Turning+Tires+In+Masterpieces.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Environment/The+Unique+Artist+Turning+Tires+In+Masterpieces.mp4",
                "filename":"",
            },          
        ]
    },
    {
        "id":19,
        "contents":25,
        "name": {
            "en": "Gaming",
            "be": "Gaming",
            "id": "Gaming",
            "it": "Gaming",
            "se": "Spel",
            "no": "Gaming",
            "fr": "Gaming",
            "ee": "Mängud",
            "lv":"Spēles",
            "lt":"Žaidimai",
            "sr":"Игре",
            "el":"Παιχνίδια",
            "de":"Spiele",
            "cs":"Hraní",
            "es": "Juego",
            "pt": "Jogos"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 751,
                "name": "5 Games You Will Lose Friends Over",
                "preview": "https://cdn.mobiotv.com/bidiotv/Gaming/5+Games+You+Will+Lose+Friends+Over.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Gaming/5+Games+You+Will+Lose+Friends+Over.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 752,
                "name": "5 Reasons to play Monster Hunter World",
                "preview": "https://cdn.mobiotv.com/bidiotv/Gaming/5+Reasons+to+play+Monster+Hunter+World.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Gaming/5+Reasons+to+play+Monster+Hunter+World.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 754,
                "name": "Best VR Experiences The survival test",
                "preview": "https://cdn.mobiotv.com/bidiotv/Gaming/Best+VR+Experiences+The+survival+test.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Gaming/Best+VR+Experiences+The+survival+test.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 755,
                "name": "Place your bets! GTA is getting a real virtual casino",
                "preview": "https://cdn.mobiotv.com/bidiotv/Gaming/Place+your+bets!+GTA+is+getting+a+real+virtual+casino.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Gaming/Place+your+bets!+GTA+is+getting+a+real+virtual+casino.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 756,
                "name": "Top 5 Gaming Lawsuits",
                "preview": "https://cdn.mobiotv.com/bidiotv/Gaming/Top+5+Gaming+Lawsuits.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Gaming/Top+5+Gaming+Lawsuits.mp4",
                "filename":"",
            }, 
            {
                "duration": "Watch Now",
                "id": 757,
                "name": "Top 5 Highest Grossing Arcade Games",
                "preview": "https://cdn.mobiotv.com/bidiotv/Gaming/Top+5+Highest+Grossing+Arcade+Games.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Gaming/Top+5+Highest+Grossing+Arcade+Games.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 758,
                "name": "Top 5 Legendary Game Couples",
                "preview": "https://cdn.mobiotv.com/bidiotv/Gaming/Top+5+Legendary+Game+Couples.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Gaming/Top+5+Legendary+Game+Couples.mp4",
                "filename":"",
            },          
        ]
    },
    {
        "id":20,
        "contents":25,
        "name": {
            "en": "Lifestyle",
            "be": "Lifestyle",
            "id": "Lifestyle",
            "it": "Stile di vita",
            "se": "Livsstil",
            "no": "Lifestyle",
            "fr": "Mode de vie",
            "ee": "Elustiil",
            "lv":"Dzīvesveids",
            "lt":"Gyvenimo būdas",
            "sr":"Начин живота",
            "el":"Τρόπος ζωής",
            "de":"Lebensstil",
            "cs":"Životní styl",
            "es": "Estilo de vida",
            "pt": "Estilo de Vida"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 759,
                "name": "Amsterdam has a plan for the Red Light District",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Amsterdam+has+a+plan+for+the+Red+Light+District.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Amsterdam+has+a+plan+for+the+Red+Light+District.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 760,
                "name": "Crazy Cravings 'I've been eating chalk for over twenty years",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Crazy+Cravings+'I've+been+eating+chalk+for+over+twenty+years'.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Crazy+Cravings+'I've+been+eating+chalk+for+over+twenty+years'.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 761,
                "name": "Crazy Cravings 'Sex toys allows me to feel confident",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Crazy+Cravings+'Sex+toys+allows+me+to+feel+confident'.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Crazy+Cravings+'Sex+toys+allows+me+to+feel+confident'.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 762,
                "name": "Dargavs Welcome to the City of the Dead",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Dargavs+Welcome+to+the+City+of+the+Dead.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Dargavs+Welcome+to+the+City+of+the+Dead.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 763,
                "name": "Dream Job  My Life As A Travel Blogger",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Dream+Job++My+Life+As+A+Travel+Blogger.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Dream+Job++My+Life+As+A+Travel+Blogger.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 764,
                "name": "Heroes Neighborhood Tour Frida Kahlo ",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Heroes+Neighborhood+Tour+Frida+Kahlo.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Heroes+Neighborhood+Tour+Frida+Kahlo.mp4",
                "filename":"",
            }, 
            {
                "duration": "Watch Now",
                "id": 765,
                "name": "Pee-quality! A new female urinal is part of a growing trend",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Pee-quality!+A+new+female+urinal+is+part+of+a+growing+trend.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Pee-quality!+A+new+female+urinal+is+part+of+a+growing+trend.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 766,
                "name": "Solo Trip Hidden Gems of Bali",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Solo+Trip+Hidden+Gems+of+Bali.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Solo+Trip+Hidden+Gems+of+Bali.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 767,
                "name": "Solo Trip Hidden Gems of Bogor (Indonesia)",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Solo+Trip+Hidden+Gems+of+Bogor+(Indonesia).jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Solo+Trip+Hidden+Gems+of+Bogor+(Indonesia).mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 768,
                "name": "Solo Trip The Hidden Gems Of Rotterdam",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Solo+Trip+The+Hidden+Gems+Of+Rotterdam.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Solo+Trip+The+Hidden+Gems+Of+Rotterdam.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 769,
                "name": "Sugary drink lovers, this one's for you!",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Sugary+drink+lovers%2C+this+one's+for+you!.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/Sugary+drink+lovers%2C+this+one's+for+you!.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 770,
                "name": "The 5 most iconic Armani red carpet looks of all time",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+5+most+iconic+Armani+red+carpet+looks+of+all+time.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+5+most+iconic+Armani+red+carpet+looks+of+all+time.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 771,
                "name": "The Most Amazing Island Canary Islands",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+Most+Amazing+Island+Canary+Islands.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+Most+Amazing+Island+Canary+Islands.mp4",
                "filename":"",
            }, 
            {
                "duration": "Watch Now",
                "id": 772,
                "name": "The Most Amazing Island Favignana Sicily",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+Most+Amazing+Island+Favignana+Sicily.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+Most+Amazing+Island+Favignana+Sicily.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 773,
                "name": "The Most Amazing Island Texel",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+Most+Amazing+Island+Texel.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/The+Most+Amazing+Island+Texel.mp4",
                "filename":"",
            }, 
            {
                "duration": "Watch Now",
                "id": 774,
                "name": "These nations give expats the best online life",
                "preview": "https://cdn.mobiotv.com/bidiotv/Lifestyle/These+nations+give+expats+the+best+online+life.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Lifestyle/These+nations+give+expats+the+best+online+life.mp4",
                "filename":"",
            },          
        ]
    },
    {
        "id":21,
        "contents":25,
        "name": {
            "en": "Local Heroes",
            "be": "Lokale helden",
            "id": "Local Heroes",
            "it": "Eroi locali",
            "se": "Lokala hjältar",
            "no": "Local Heroes",
            "fr": "Héros locaux",
            "ee": "Kohalikud kangelased",
            "lv":"Vietējie varoņi",
            "lt":"Vietiniai herojai",
            "sr":"Локални хероји",
            "el":"Τοπική Ήρωες",
            "de":"Lokale Helden",
            "cs":"Místní hrdinové",
            "es": "Héroes locales",
            "pt": "Heróis Locais"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 775,
                "name": "There’s no power from keeping it to yourself'",
                "preview": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/'There%E2%80%99s+no+power+from+keeping+it+to+yourself'.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/'There%E2%80%99s+no+power+from+keeping+it+to+yourself'.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 776,
                "name": "3 Things Malala has said that will totally inspire you",
                "preview": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/3+Things+Malala+has+said+that+will+totally+inspire+you.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/3+Things+Malala+has+said+that+will+totally+inspire+you.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 777,
                "name": "Border Angels Saving lives with water",
                "preview": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Border+Angels+Saving+lives+with+water.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Border+Angels+Saving+lives+with+water.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 778,
                "name": "Bullied To Influencer 'Painting helps me dodge my problems",
                "preview": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Bullied+To+Influencer+'Painting+helps+me+dodge+my+problems'.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Bullied+To+Influencer+'Painting+helps+me+dodge+my+problems'.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 779,
                "name": "Bullied to Influencer 'You can be the light in the darkness",
                "preview": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Bullied+to+Influencer+'You+can+be+the+light+in+the+darkness'.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Bullied+to+Influencer+'You+can+be+the+light+in+the+darkness'.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 780,
                "name": "Peace Builders Fighting gangs with clowning",
                "preview": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Peace+Builders+Fighting+gangs+with+clowning.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Peace+Builders+Fighting+gangs+with+clowning.mp4",
                "filename":"",
            }, 
            {
                "duration": "Watch Now",
                "id": 781,
                "name": "Peacebuilders Inside the Community Ring",
                "preview": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Peacebuilders+Inside+the+Community+Ring.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Peacebuilders+Inside+the+Community+Ring.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 782,
                "name": "Sport for Change A sure shot to female empowerment in Zimbabwe",
                "preview": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Sport+for+Change+A+sure+shot+to+female+empowerment+in+Zimbabwe.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Sport+for+Change+A+sure+shot+to+female+empowerment+in+Zimbabwe.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 783,
                "name": "Young CEO Mr. Cory’s Cookies",
                "preview": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Young+CEO+Mr.+Cory%E2%80%99s+Cookies.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Local+Heroes/Young+CEO+Mr.+Cory%E2%80%99s+Cookies.mp4",
                "filename":"",
            }
        ]
    },
    {
        "id":22,
        "contents":25,
        "name": {
            "en": "Sports",
            "be": "Sport nieuws",
            "id": "Sports",
            "it": "Sport",
            "se": "Sporter",
            "no": "Sports",
            "fr": "Sports",
            "ee": "Spordiuudised",
            "lv":"Sports",
            "lt":"Sportas",
            "sr":"Спорт",
            "el":"Αθλητικά νέα",
            "de":"Sport",
            "cs":"Sport",
            "es": "Deportes",
            "pt": "Esportes"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 784,
                "name": "Amazing Tennis Courts A Court Hidden Among Cliffs",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports+News/Amazing+Tennis+Courts+A+Court+Hidden+Among+Cliffs.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Sports+News/Amazing+Tennis+Courts+A+Court+Hidden+Among+Cliffs.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 785,
                "name": "Best VR Experiences The extreme sports simulator",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports+News/Best+VR+Experiences+The+extreme+sports+simulator.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Sports+News/Best+VR+Experiences+The+extreme+sports+simulator.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 786,
                "name": "Don’t expect the U.S. Women’s Football squad at the White House",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports+News/Don%E2%80%99t+expect+the+U.S.+Women%E2%80%99s+Football+squad+at+the+White+House.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Sports+News/Don%E2%80%99t+expect+the+U.S.+Women%E2%80%99s+Football+squad+at+the+White+House.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 787,
                "name": "Future Female Footballer Colombia's Salomé is gonna be a pro",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports+News/Future+Female+Footballer+Colombia's+Salome%CC%81+is+gonna+be+a+pro.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Sports+News/Future+Female+Footballer+Colombia's+Salome%CC%81+is+gonna+be+a+pro.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 788,
                "name": "My Underground Sport Alan Nasty Nash is a champ toe wrestler",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Sports+News/My+Underground+Sport+Alan+Nasty+Nash+is+a+champ+toe+wrestler.mp4",
                "desc": "",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports+News/My+Underground+Sport+Alan+Nasty+Nash+is+a+champ+toe+wrestler.jpg",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 789,
                "name": "My Underground Sport Kabaddi's growing in India",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports+News/My+Underground+Sport+Kabaddi's+growing+in+India.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Sports+News/My+Underground+Sport+Kabaddi's+growing+in+India.mp4",
                "filename":"",
            }, 
            {
                "duration": "Watch Now",
                "id": 790,
                "name": "Sport for Change A goal for inclusion",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports+News/Sport+for+Change+A+goal+for+inclusion.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Sports+News/Sport+for+Change+A+goal+for+inclusion.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 791,
                "name": "Sport for Change The initiative hitting it out of the park",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports+News/Sport+for+Change+The+initiative+hitting+it+out+of+the+park.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Sports+News/Sport+for+Change+The+initiative+hitting+it+out+of+the+park.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 792,
                "name": "The 5 best summer football transfers so far!",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports+News/The+5+best+summer+football+transfers+so+far!.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Sports+News/The+5+best+summer+football+transfers+so+far!.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 14,
                "name": "Coaches Clinic Pete Herrman",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports/Coaches+Clinic++Pete+Herrman.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Sports/Coaches+Clinic++Pete+Herrman.mp4",
                "filename":"bidiotv/Sports/Coaches+Clinic+Pete+Herrman.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 15,
                "name": "Dribble Drive Motion Skills",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports/Dribble+Drive+Motion+Skills.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Sports/Dribble+Drive+Motion+Skills.mp4",
                "filename":"bidiotv/Sports/Dribble+Drive+Motion+Skills.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 16,
                "name": "GAMCA Coaches Clinic",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports/GAMCA+Coaches+Clinic.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Sports/GAMCA+Coaches+Clinic.mp4",
                "filename":"bidiotv/Sports/GAMCA+Coaches+Clinic.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 17,
                "name": "Robert Tutein (UTICA) - 2016 GEICO Play of the Year Nominee",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports/ROBERT+TUTEIN+(UTICA)+-+2016+GEICO+Play+of+the+Year+Nominee.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Sports/ROBERT+TUTEIN+(UTICA)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
                "filename":"bidiotv/Sports/ROBERT+TUTEIN+(UTICA)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 18,
                "name": "Ryan Kelley (ARCADIA) - 2016 GEICO Play of the Year Nominee",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports/RYAN+KELLEY+(ARCADIA)+-+2016+GEICO+Play+of+the+Year+Nominee.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Sports/RYAN+KELLEY+(ARCADIA)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
                "filename":"bidiotv/Sports/RYAN+KELLEY+(ARCADIA)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 19,
                "name": "Sam Borst Smith (ROCHESTER) - 2016 GEICO Play of the Year Nominee",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports/SAM+BORST+SMITH+(ROCHESTER)+-+2016+GEICO+Play+of+the+Year+Nominee.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Sports/SAM+BORST+SMITH+(ROCHESTER)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
                "filename":"bidiotv/Sports/SAM+BORST+SMITH+(ROCHESTER)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 20,
                "name": "Special Spectators visits the College Slam Dunk & 3- Point Championships Intersport",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports/Special+Spectators+visits+the+College+Slam+Dunk+%26+3-Point+Championships+Intersport.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Sports/Special+Spectators+visits+the+College+Slam+Dunk+%26+3-Point+Championships+Intersport.mp4",
                "filename":"bidiotv/Sports/Special+Spectators+visits+the+College+Slam+Dunk+%26+3-Point+Championships+Intersport.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 21,
                "name": "Tanner Schieve (Wisconsin Lutheran College) - 2016 GEICO Play of the Year Nominee",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports/Tanner+Schieve+(Wisconsin+Lutheran+College)+-+2016+GEICO+Play+of+the+Year+Nominee.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Sports/Tanner+Schieve+(Wisconsin+Lutheran+College)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
                "filename":"bidiotv/Sports/Tanner+Schieve+(Wisconsin+Lutheran+College)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 22,
                "name": "Trevor Krizenesky (Concordia University Wisconsin) - 2016 GEICO Play of the Year Nominee",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports/Trevor+Krizenesky+(Concordia+University+-+Wisconsin)+-+2016+GEICO+Play+of+the+Year+Nominee.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Sports/Trevor+Krizenesky+(Concordia+University+-+Wisconsin)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
                "filename":"bidiotv/Sports/Trevor+Krizenesky+(Concordia+University+-+Wisconsin)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 23,
                "name": "Venky Jois (EASTERN WASHINGTON) - 2016 GEICO Play of the Year Nominee",
                "preview": "https://cdn.mobiotv.com/bidiotv/Sports/VENKY+JOIS+(EASTERN+WASHINGTON)+-+2016+GEICO+Play+of+the+Year+Nominee.jpg",
                "desc": "",
                "videoUrl": "https://cdn.bidiotv.com/Sports/VENKY+JOIS+(EASTERN+WASHINGTON)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
                "filename":"bidiotv/Sports/VENKY+JOIS+(EASTERN+WASHINGTON)+-+2016+GEICO+Play+of+the+Year+Nominee.mp4",
            },
            {
                "duration": "Watch Now",
                "id": 801,
                "name": "Learn Freestyle Football Tricks Lemmens around the world",
                "preview": "https://cdn.mobiotv.com/bidiotv/Tutorials/Learn+Freestyle+Football+Tricks+Lemmens+around+the+world.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Tutorials/Learn+Freestyle+Football+Tricks+Lemmens+around+the+world.mp4",
                "filename": "",
            },
            {
                "duration": "Watch Now",
                "id": 802,
                "name": "Pro Footballer Training A Need For Speed",
                "preview": "https://cdn.mobiotv.com/bidiotv/Tutorials/Pro+Footballer+Training+A+Need+For+Speed.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Tutorials/Pro+Footballer+Training+A+Need+For+Speed.mp4",
                "filename": "",
            },
            {
                "duration": "Watch Now",
                "id": 803,
                "name": "Pro Footballer Training Leg-Focused Exercises",
                "preview": "https://cdn.mobiotv.com/bidiotv/Tutorials/Pro+Footballer+Training+Leg-Focused+Exercises.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Tutorials/Pro+Footballer+Training+Leg-Focused+Exercises.mp4",
                "filename": "",
            },
            {
                "duration": "Watch Now",
                "id": 804,
                "name": "Pro Footballer Training Muscles-Focused Exercises",
                "preview": "https://cdn.mobiotv.com/bidiotv/Tutorials/Pro+Footballer+Training+Muscles-Focused+Exercises.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Tutorials/Pro+Footballer+Training+Muscles-Focused+Exercises.mp4",
                "filename": "",
            }
        ]
    },
    {
        "id":23,
        "contents":25,
        "name": {
            "en": "Technology",
            "be": "Technologie",
            "id": "Technology",
            "it": "Tecnologia",
            "se": "Teknologi",
            "no": "Technology",
            "fr": "Technologie",
            "ee": "Tehnoloogia",
            "lv":"Tehnoloģija",
            "lt":"Technologijos",
            "sr":"Технологија",
            "el":"Τεχνολογία",
            "de":"Technik",
            "cs":"Technologie",
            "es": "Tecnología",
            "pt": "Tecnologia"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 793,
                "name": "Best VR Experiences Into the shark tank",
                "preview": "https://cdn.mobiotv.com/bidiotv/Technology/Best+VR+Experiences+Into+the+shark+tank.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Technology/Best+VR+Experiences+Into+the+shark+tank.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 794,
                "name": "From Human to Cyborg",
                "preview": "https://cdn.mobiotv.com/bidiotv/Technology/From+Human+to+Cyborg.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Technology/From+Human+to+Cyborg.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 795,
                "name": "Futuristic Transport Getting around never looked so cool",
                "preview": "https://cdn.mobiotv.com/bidiotv/Technology/Futuristic+Transport+Getting+around+never+looked+so+cool.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Technology/Futuristic+Transport+Getting+around+never+looked+so+cool.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 796,
                "name": "NASA’s next destination in 2026 Titan",
                "preview": "https://cdn.mobiotv.com/bidiotv/Technology/NASA%E2%80%99s+next+destination+in+2026+Titan.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Technology/NASA%E2%80%99s+next+destination+in+2026+Titan.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 797,
                "name": "Visit a Space Place Korolev, Russia's deep space history",
                "preview": "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+Korolev%2C+Russia's+deep+space+history.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+Korolev%2C+Russia's+deep+space+history.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 798,
                "name": "Visit a Space Place The Meteor Crater",
                "preview": "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+The+Meteor+Crater.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+The+Meteor+Crater.mp4",
                "filename":"",
            }, 
            {
                "duration": "Watch Now",
                "id": 799,
                "name": "Visit a Space Place The Netherlands' Space Simulator",
                "preview": "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+The+Netherlands'+Space+Simulator.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Technology/Visit+a+Space+Place+The+Netherlands'+Space+Simulator.mp4",
                "filename":"",
            }
        ]
    },
    {
        "id":24,
        "contents":25,
        "name": {
            "en": "Tutorials",
            "be": "tutorials",
            "id": "Tutorials",
            "it": "Esercitazioni",
            "se": "Tutorials",
            "no": "Tutorials",
            "fr": "Tutoriels",
            "ee": "Koolitused",
            "lv":"Pamācības",
            "lt":"Pamokos",
            "sr":"Туториали",
            "el":"Σεμινάρια",
            "de":"Anleitungen",
            "cs":"Tutoriály",
            "es": "Tutoriales",
            "pt": "Tutoriais"
        },
        "videos":[
            {
                "duration": "Watch Now",
                "id": 800,
                "name": "How To be green at home Natural Stain Remover",
                "preview": "https://cdn.mobiotv.com/bidiotv/Tutorials/How+To+be+green+at+home+Natural+Stain+Remover.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Tutorials/How+To+be+green+at+home+Natural+Stain+Remover.mp4",
                "filename":"",
            },
            {
                "duration": "Watch Now",
                "id": 811,
                "name": "Wanna be a DJ Start with the basics from a pro",
                "preview": "https://cdn.mobiotv.com/bidiotv/Tutorials/Wanna+be+a+DJ+Start+with+the+basics+from+a+pro.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/bidiotv/Tutorials/Wanna+be+a+DJ+Start+with+the+basics+from+a+pro.mp4",
                "filename":"",
            }
        ]
    }
];


// WEBPACK FOOTER //
// ./src/constants/bidiotvmovies.js